var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense, useCallback, useEffect, useMemo, useState, } from "react";
import { useStyles } from "./assets/style";
import "./assets/style.css"; // @ts-ignore
import { icons, sizesIcon, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams, useSearchParams, } from "react-router-dom";
import { themeCore } from "../../assets/themes/theme";
import * as catalogConst from "../../const/catalog";
import { STEP_CONFIRMATIONFORM } from "../../const/catalog";
import { formatPhoneNumber } from "../../utils/formats";
import { navigateNext, stepProgress } from "../../dataBase/stepProgress";
import { Customer } from "../../enum/customer";
import { CONFIRMATION_FORM_ORIGIN_PARAM, resolveLegacyBackRoute, } from "../../enum/confirmationFormOrigin";
import { Steps } from "../../enum/steps";
import { PostUploadDocuments } from "../../fnx/apaAuditDocuments/quoteUploadDocuments";
import { GetCatalogBeneficiary } from "../../fnx/catalog/getCatalogBeneficiary";
import { GetCatalogInsurance } from "../../fnx/catalog/getCatalogInsurance";
import { GetPaymentMode } from "../../fnx/paymentMode/getPaymentMode";
import { useCertificateQuote } from "../../fnx/certificate/certificateQuotes";
import { getCustomerAction, isAcap, isCustomer } from "../../fnx/customer";
import { GetPersonByDocument } from "../../fnx/person/getPersonByDocument";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { formatDocument, getLogin, transformToSelect, } from "../../services/functions";
import { hasPermission } from "../../services/getNavigationPages";
import LocalStorageService from "../../services/localStorage";
import showToast from "../../services/toast";
import { postQuoteUploadDocumentClearData } from "../../store/apapUploadAttachments/actions";
import { benefitClearData, getBeneficiary, patchBeneficiaryClearData, } from "../../store/beneficiary/actions";
import { certificateQuoteClearData } from "../../store/certificates/actions";
import { countries } from "../../store/countries/actions";
import { quoteClearData, quoteOne } from "../../store/generateQuote/actions";
import { identificationType } from "../../store/identificationType/actions";
import { deleteInsured as deleteInsuredAction, deleteInsuredClearData, insured, patchInsuredClearData, postInsuredClearData, } from "../../store/insured/actions";
import { pageActionFlagsClearData } from "../../store/pageActionFlags/actions";
import { personByDocumentClearData, updatePersonClearData, } from "../../store/person/actions";
import { projectOne, projectOneClearData } from "../../store/project/actions";
import { catalogGender } from "../../store/plan/actions";
import { plans } from "../../store/plans/actions";
import { region } from "../../store/region/actions";
import { Branches } from "../../store/branches/actions";
import { patchQuoteClearData } from "../../store/updateQuote/actions";
import { patchQuoteAPI } from "../../resources/helper/updateQuote";
import { formattedDate, formattedDateTime, newFormattedDate, } from "../../utils/date";
import { formatNumberCustom, formatToTwoDecimals, parsePrice, } from "../../utils/getPrice";
import { AdditionalDocumentationColumns, dataEditVehicleForm, rowsClientDocument, StatementColumns, Tab1Columns, Tab2Columns, Tab3Columns, Tab4Columns, TabAppointmentColumns, TabAppointmentManagerColumns, TabAutoColumns, TabCardInfoColumns, } from "./resources/confirmationFormDto";
import { ConfirmationFormView } from "./ui/view"; /* Beneficiary */
import useBeneficiary from "./components/beneficiary"; /* Insurance */
import useInsurance from "./components/insurance"; /* Vehicle */
import useVehicle from "./components/vehicle"; /* ConfirmationForm */
import useClient from "./components/client"; /* Form Actions */
import useActions from "./components/ui"; /* Selectors */
import useSelectors from "./components/selectors"; /* Functions */
import useFunctions from "./components/functions";
import { PassengerDownloadModal } from "./resources/PassengerDownloadModal";
import PagesHeader from "ah_utility/PagesHeader";
import { showErrorToast } from "../../fnx/showError";
import { runToastOf } from "../../hooks/legacyConversion/legacyConversion.rules";
import { useLegacyConversionRun } from "../../hooks/legacyConversion/useLegacyConversionRun";
import { useGetSteps } from "../../utils/getSteps";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { ConfirmationHeader } from "./header";
import { addStepInformationToAllSteps, useGetInformationSteps, } from "ah_utility/workflow";
import { useGetSummary } from "../../utils/getSummary";
import { useStepNavigation } from "ah_utility/NavigationEngine";
import { formAddBusiness } from "./resources/FormsBusinessDTO";
import { useCatalogues } from "../addBusiness/hooks/useCatalogues";
import { useStartWokFlow } from "../../fnx/workFlow/startWorkFlow";
import { startWorkFlowClearData } from "../../store/workFlow/actions";
import { policyConfirm, policyConfirmClearData, } from "../../store/policy/actions";
import { addToSummary, getFlagValue } from "ah_utility/fnxUtils";
import usePaymentConfirmation from "../paymentConfirmation/components/paymentConfirmation";
import { useErrorHandling } from "./hooks/useErrorHandling";
import { useAppointment } from "./hooks/useAppointment";
import { useAppointmentManager } from "./hooks/useAppointmentManager";
import { useQuoteComments } from "./hooks/useQuoteComments";
import { useAuditLogs } from "./hooks/useAuditLogs";
import { useMailHistory } from "./hooks/useMailHistory";
import { useGetLegacyQuote } from "./hooks/useGetLegacyQuote";
import { useGetLegacyQuoteDetail } from "./hooks/useGetLegacyQuoteDetail";
import { useLegacyQuoteDataForm } from "./hooks/useLegacyQuoteDataForm";
var STEP = STEP_CONFIRMATIONFORM;
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
var storageKey3 = "afy-action-flags";
var lsPageActionFlags = new LocalStorageService(storageKey3);
var storageKey4 = "afy-steps";
var lsSteps = new LocalStorageService(storageKey4);
var CERTIFICATES_CONVERSION_REQUEST_KEY = "confirmationFormCertificatesConversion";
var LEGACY_FILTERS_PLACEHOLDER = [
    { name: "Producto", label: "-", type: "label" },
    { name: "Plan", label: "-", type: "label" },
    { name: "Modalidad de pago", label: "-", type: "label" },
    { name: "Prima", label: "-", type: "label" },
];
var ConfirmationForm = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26;
    var permissions = {
        create: hasPermission("sale-confirmation-form-create"),
    };
    // -- DATA & STATES BUSINESS HOME
    var _27 = React.useState(false), openModalAddBusiness = _27[0], setOpenModalAddBusiness = _27[1];
    var _28 = React.useState(false), showTabRealEstates = _28[0], setShowTabRealEstates = _28[1];
    var _29 = useState(formAddBusiness), dataFormBusiness = _29[0], setDataFormBusiness = _29[1];
    var _30 = React.useState(false), isCommerce = _30[0], setIsCommerce = _30[1];
    var _31 = useState(""), provinceId = _31[0], setProvinceId = _31[1];
    var _32 = useState(""), townId = _32[0], setTowId = _32[1];
    var _33 = useState(""), sectorId = _33[0], setSectorId = _33[1];
    var _34 = useState(""), planCode = _34[0], setPlanCode = _34[1];
    var _35 = useState(""), productCode = _35[0], setProductCode = _35[1];
    var _36 = useState([]), rowsProperties = _36[0], setRowsProperties = _36[1];
    var _37 = useState(""), propertyTypeId = _37[0], setPropertyTypeId = _37[1];
    var _38 = React.useState(""), damageBackup = _38[0], setDamageBackup = _38[1];
    var _39 = React.useState(""), insuredProperty = _39[0], setInsuredProperty = _39[1];
    // HOME
    var _40 = React.useState(false), openModalAddHome = _40[0], setOpenModalAddHome = _40[1];
    var _41 = React.useState(false), showFormBusiness = _41[0], setShowFormBusiness = _41[1];
    // -- END DATA & STATES BUSINESS HOME
    //APPOINMENT
    var _42 = React.useState(false), showTabAppointment = _42[0], setShowTabAppointment = _42[1];
    var _43 = React.useState(false), showTabAppointmentManager = _43[0], setShowTabAppointmentManager = _43[1];
    var _44 = React.useState(true), addAppointmentAction = _44[0], setAddAppointmentAction = _44[1];
    var _45 = React.useState(false), openModalAddAppointmentAction = _45[0], setOpenModalAddAppointmentAction = _45[1];
    var t = useTranslation().t;
    var classes = useStyles();
    var storageKey = "afy-steps";
    var localStorageService = new LocalStorageService(storageKey);
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _46 = React.useState(lsPageActionFlags.getPageActionFlagsStored()), actionFlags = _46[0], setActionFlags = _46[1];
    var _47 = React.useState(((_a = lsPageActionFlags.getPageActionFlagsStored()) !== null && _a !== void 0 ? _a : []).length > 0), actionFlagsLoaded = _47[0], setActionFlagsLoaded = _47[1];
    var afy_label_premium = (_b = actionFlags.find(function (x) { return x.name === "afy-label-summary-premium"; })) === null || _b === void 0 ? void 0 : _b.value;
    var afy_currency = (_c = actionFlags.find(function (x) { return x.name === "afy-plan-currency"; })) === null || _c === void 0 ? void 0 : _c.value;
    var _48 = useState(""), planId = _48[0], setPlanId = _48[1];
    var _49 = React.useState(false), openDrawerUpload = _49[0], setOpenDrawerUpload = _49[1];
    var _50 = React.useState(""), idDocumentClient = _50[0], setIdDocumentClient = _50[1];
    var _51 = useState(""), coverTypeId = _51[0], setCoverTypeId = _51[1];
    var _52 = useState(""), campaignId = _52[0], setCampaignId = _52[1];
    var _53 = useState(""), catalogPaymentMode = _53[0], setCatalogPaymentMode = _53[1];
    var _54 = useState(""), catalogStatusQuote = _54[0], setCatalogStatusQuote = _54[1];
    var _55 = useState(""), policyStatus = _55[0], setPolicyStatus = _55[1];
    var _56 = useState([]), paymentMethodCardData = _56[0], setPaymentMethodCardData = _56[1];
    var _57 = useState(""), branchId = _57[0], setBranchId = _57[1];
    var userId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _58 = React.useState(false), uploadTrigger = _58[0], setUploadTrigger = _58[1];
    var isVidaTermino = isCustomer(Customer.VIDA);
    var _59 = React.useState(""), period = _59[0], setPeriod = _59[1];
    var _60 = React.useState([]), breadCrumbs = _60[0], setBreadCrumbs = _60[1];
    var _61 = React.useState(false), showInsured = _61[0], setShowInsured = _61[1];
    var _62 = React.useState(false), showNewFormInsurance = _62[0], setShowNewFormInsurance = _62[1];
    var _63 = React.useState(false), showBeneficiary = _63[0], setShowBeneficiary = _63[1];
    var _64 = React.useState(true), addInsured = _64[0], setAddInsured = _64[1];
    var _65 = React.useState(true), addBeneficiary = _65[0], setAddBeneficiary = _65[1];
    var _66 = React.useState(false), showComponent = _66[0], setShowComponent = _66[1];
    var _67 = useState(false), openModalBackConfirm = _67[0], setOpenModalBackConfirm = _67[1];
    var _68 = React.useState(true), canEdit = _68[0], setCanEdit = _68[1];
    var _69 = React.useState(false), showDownloads = _69[0], setShowDownloads = _69[1];
    var _70 = React.useState(false), canEditLocation = _70[0], setCanEditLocation = _70[1];
    var _71 = React.useState(false), canEditContact = _71[0], setCanEditContact = _71[1];
    var _72 = React.useState([]), certificates = _72[0], setCertificates = _72[1];
    var _73 = useState([]), rows = _73[0], setRows = _73[1];
    var _74 = useState([]), rows2 = _74[0], setRows2 = _74[1];
    var _75 = useState([]), rowsCardInfo = _75[0], setRowsCardInfo = _75[1];
    var _76 = useState([]), rowsBeneficiary = _76[0], setRowsBeneficiary = _76[1];
    var _77 = useState([]), rowsPassengers = _77[0], setRowsPassengers = _77[1];
    var _78 = React.useState(false), openActivePolicy = _78[0], setOpenActivePolicy = _78[1];
    var activatePolicy = useParams().activatePolicy;
    var _79 = React.useState(""), policyId = _79[0], setPolicyId = _79[1];
    var _80 = React.useState(false), hideMarriedName = _80[0], setHideMarriedName = _80[1];
    var _81 = React.useState(""), namePlan = _81[0], setNamePlan = _81[1];
    var _82 = useState(false), isMaskedDocument = _82[0], setIsMaskedDocument = _82[1];
    var _83 = useState(""), personQuoteId = _83[0], setPersonQuoteId = _83[1];
    var _84 = useState(""), prime = _84[0], setPrime = _84[1];
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _85 = React.useState(true), enable = _85[0], setEnable = _85[1];
    var _86 = React.useState([]), listIdentificationType = _86[0], setListIdentificationType = _86[1];
    var _87 = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _87[0], setSeeToast = _87[1];
    var id = useParams().id;
    var isQuote = useParams().isQuote;
    var isPlan = useParams().isPlan;
    var idProject = useParams().idProject;
    var isDocumentClient = useParams().isDocumentClient;
    var _88 = React.useState(false), projectTrigger = _88[0], setProjectTrigger = _88[1];
    var _89 = React.useState(false), triggerCatalog = _89[0], setTriggerCatalog = _89[1];
    var _90 = React.useState(false), triggerCatalogInsurance = _90[0], setTriggerCatalogInsurance = _90[1];
    var _91 = React.useState(false), triggerPaymentMode = _91[0], setTriggerPaymentMode = _91[1];
    var _92 = React.useState(false), triggerCertificate = _92[0], setTriggerCertificate = _92[1];
    var _93 = useState([]), listGenders = _93[0], setListGenders = _93[1];
    var _94 = useState(isQuote === "true"), isQuoteType = _94[0], setIsQuoteType = _94[1];
    var _95 = useState(true), canEditBeneficiary = _95[0], setCanEditBeneficiary = _95[1];
    var _96 = useState(true), canEditInsured = _96[0], setCanEditInsured = _96[1];
    var _97 = useState([]), listCountries = _97[0], setListCountries = _97[1];
    var _98 = useState([]), listRegionLevel1 = _98[0], setListRegionLevel1 = _98[1];
    var _99 = useState([]), listRegionLevel2 = _99[0], setListRegionLevel2 = _99[1];
    var _100 = useState([]), listRegionLevel3 = _100[0], setListRegionLevel3 = _100[1];
    var _101 = React.useState(1), page = _101[0], setPage = _101[1];
    var _102 = React.useState(""), idQuoteVehicle = _102[0], setIdQuoteVehicle = _102[1];
    var _103 = React.useState(""), productId = _103[0], setProductId = _103[1];
    var _104 = React.useState(10000), limit = _104[0], setLimit = _104[1];
    var _105 = React.useState(false), openModal = _105[0], setOpenModal = _105[1];
    var _106 = React.useState(false), openModalAddInsurance = _106[0], setOpenModalAddInsurance = _106[1];
    var _107 = React.useState(false), openModalPdfViewer = _107[0], setopenModalPdfViewer = _107[1];
    var _108 = React.useState(""), urlDocument = _108[0], setUrlDocument = _108[1];
    var _109 = React.useState(""), nameDocument = _109[0], setNameDocument = _109[1];
    var _110 = React.useState(""), personId = _110[0], setPersonId = _110[1];
    var _111 = React.useState(false), openModalBeneficiary = _111[0], setOpenModalBeneficiary = _111[1];
    var _112 = React.useState(transformToSelect(localStorageService.getStepStored().steps[Steps.plan].paymentMode)), paymentMode = _112[0], setPaymentMode = _112[1];
    var _113 = React.useState([
        { id: 1, name: "Sin datos", value: "-1" },
    ]), coverageType = _113[0], setCoverageType = _113[1];
    var _114 = React.useState([
        { id: 1, name: "Sin datos", value: "-1", code: "" },
    ]), insuredType = _114[0], setInsuredType = _114[1];
    var _115 = React.useState([
        { id: 1, name: "Sin datos", value: "-1" },
    ]), beneficiaryType = _115[0], setBeneficiaryType = _115[1];
    var _116 = React.useState(findParamInLocalStorage("campaign", "steps")), campaign = _116[0], setCampaign = _116[1];
    var _117 = React.useState(findParamInLocalStorage("campaign", "steps")), campaigns = _117[0], setCampaigns = _117[1];
    var _118 = React.useState(""), planName = _118[0], setPlanName = _118[1];
    var _119 = React.useState({
        id: "",
        name: "",
        value: "",
    }), campaignSelected = _119[0], setCampaignSelected = _119[1];
    var _120 = React.useState({
        id: "",
        name: "",
    }), plan = _120[0], setPlan = _120[1];
    var _121 = React.useState(false), openModalEditVehicle = _121[0], setOpenModalEditVehicle = _121[1];
    var steps = useGetSteps();
    var _122 = React.useState({
        titlePage: "Plan",
        viewType: "2",
        titleMetaTag: "Affinity Plan",
        informationPage: {
            backgroundColor: themeCore.colors.background,
            colorText: themeCore.colors.secondaryText,
            description: "Seleccion el plan que necesite el cliente",
            icon: icons.Help,
            iconSize: sizesIcon.standard,
            iconColor: themeCore.colors.primary,
        },
        filter: {
            backgroundColor: "#FFFFFF",
            bgChipInsurers: "#fff",
            bgChipInsurersSelected: "#EBEEF6",
            bgColorButton: "#fff",
            bgColorComparativeButton: "#3A56A1",
            bgColorIconButton: "#EBEEF6",
            bgColorIconButtonSelected: "#3A56A1",
            colorIconButton: "#3A56A1",
            colorIconButtonSelected: "#fff",
            colorIconChip: "#3A56A1",
            colorText: "#3A56A1",
            comparativeTextButton: "ver comparativa",
            comparativeTextColor: "#fff",
            insurers: [],
            title: "Patrocinador",
            titleFirstChip: "Todas",
        },
        data: [],
    }), planData = _122[0], setPlanData = _122[1];
    var _123 = React.useState(localStorageService.getStepStored().steps[Steps.insurance].campaign), campaignInfo = _123[0], setCampaignInfo = _123[1];
    var level1 = "REGION_LEVEL1";
    var level2 = "REGION_LEVEL2";
    var level3 = "REGION_LEVEL3";
    var _124 = React.useState(), coverType = _124[0], setCoverType = _124[1];
    var _125 = useState("Confirmación de Datos"), titleInsured = _125[0], setTitleInsured = _125[1];
    var _126 = useState("Ingresar beneficiario"), titleBeneficiary = _126[0], setTitleBeneficiary = _126[1];
    var _127 = React.useState(""), projectId = _127[0], setProjectId = _127[1];
    var _128 = React.useState(false), isTravelInsurance = _128[0], setIsTravelInsurance = _128[1];
    // Get passenger counts from localStorage and calculate sum
    var edad020 = parseInt(findParamInLocalStorage("edad020") || "0");
    var edad2174 = parseInt(findParamInLocalStorage("edad2174") || "0");
    var edad7585 = parseInt(findParamInLocalStorage("edad7585") || "0");
    var _129 = React.useState(edad020 + edad2174 + edad7585), premiumSum = _129[0], setPremiumSum = _129[1];
    var _130 = useState(false), isUpdate = _130[0], setIsUpdate = _130[1];
    var _131 = React.useState(dataEditVehicleForm), dataFormVehicle = _131[0], setDataFormVehicle = _131[1];
    var _132 = useState({
        DocumentNumber: "",
        QuoteNumber: "",
        policeNumber: "",
        QuoteStatusName: "",
        QuoteDate: "",
        Type: "",
        PlanTypeName: "",
        CampaignName: "-",
        IdTypeName: "",
        Name: "",
        SecondName: "",
        FirstLastName: "",
        SecondLastName: "",
        MarriedSurName: "-",
        Gender: "",
        Birthday: "",
        Address1: "-",
        Address2: "-",
        CountryName: "",
        ProvinceName: "",
        TownName: "",
        SectorName: "",
        PostalCode: "",
        PhoneOffice: "",
        PhoneHome: "-",
        PhoneNumber: "-",
        Email: "",
    }), dataForm = _132[0], setDataForm = _132[1];
    var _133 = useState({
        Id: "",
        IdType: "",
        idTypeInsured: "",
        Percentage: "",
        DocumentNumber: "",
        Name: "",
        LastNameA: "",
        LastNameB: "",
        marriedName: "",
        Birthday: "",
        PhoneNumber: "",
        IdTypeName: "",
    }), dataFormBeneficiary = _133[0], setDataFormBeneficiary = _133[1];
    var _134 = useState({
        Id: "",
        IdType: "",
        idInsuredType: "",
        DocumentNumber: "",
        Name: "",
        LastNameA: "",
        LastNameB: "",
        marriedName: "",
        Birthday: "",
        PhoneNumber: "",
        IdTypeName: "",
    }), dataFormInsurance = _134[0], setDataFormInsurance = _134[1];
    var _135 = useState({
        idType: "",
        documentNumber: "",
        idInsuredType: "",
        firstName: "",
        secondName: "",
        lastNameA: "",
        lastNameB: "",
        birthday: "",
        gender: "",
        marriedName: "",
        country: "",
        province: "",
        town: "",
        sector: "",
        postalCode: "",
        address1: "",
        phoneHome: "",
        phoneNumber: "",
        phoneOffice: "",
        email: "",
    }), dataFormInsuranceSp = _135[0], setDataFormInsuranceSp = _135[1];
    var _136 = useState(""), insuranceType = _136[0], setInsuranceType = _136[1];
    var _137 = useState(45), initialPercentage = _137[0], setInitialPercentage = _137[1];
    var _138 = useState(false), trigger = _138[0], setTrigger = _138[1];
    var _139 = useState(), document = _139[0], setDocument = _139[1];
    var _140 = useState(false), isInsurance = _140[0], setIsInsurance = _140[1];
    var _141 = useState([]), listVehiclesDetail = _141[0], setListVehicles = _141[1];
    var _142 = React.useState({}), salesFlow = _142[0], setSalesFlow = _142[1];
    var _143 = React.useState([]), statementRows = _143[0], setStatementRows = _143[1];
    var _144 = React.useState([]), filters = _144[0], setFilters = _144[1];
    var _145 = React.useState([]), defaultFilters = _145[0], setDefaultFilters = _145[1];
    var _146 = React.useState(rowsClientDocument), profileDocumentsRows = _146[0], setProfileDocumentsRows = _146[1];
    var _147 = React.useState(0), countBadge = _147[0], setCountBadge = _147[1];
    var carDetails = React.useState((_d = lsSteps.getStepStored().steps[Steps.vehiclesDetails]) === null || _d === void 0 ? void 0 : _d.vehiclesDetails)[0];
    var company = React.useState(lsLogin.getUserLoginStored().subdomain || "")[0];
    var isApapAuto = getCustomerAction().customerAuto.includes(company);
    var isAcapCompany = isAcap(company);
    var _148 = useState(true), hideTabDocumentClient = _148[0], setHideTabDocumentClient = _148[1];
    var _149 = useState(true), hideTabPaymentInfo = _149[0], setHideTabPaymentInfo = _149[1];
    var isNotQuote = isQuote !== "false";
    var _150 = React.useState(""), fileName = _150[0], setFileName = _150[1];
    var _151 = React.useState(), pdfFile = _151[0], setPdfFile = _151[1];
    var _152 = React.useState(false), modalDocumentClient = _152[0], setModalDocumentClient = _152[1];
    var _153 = React.useState(""), urlDocumentClient = _153[0], setUrlDocumentClient = _153[1];
    var _154 = React.useState("false"), docName = _154[0], setDocName = _154[1];
    var _155 = React.useState(false), openModalPassenger = _155[0], setOpenModalPassenger = _155[1];
    var _156 = React.useState(""), urlDocumentPassenger = _156[0], setUrlDocumentPassenger = _156[1];
    var _157 = React.useState(""), nameDocumentPassenger = _157[0], setNameDocumentPassenger = _157[1];
    var _158 = React.useState(((_e = localStorageService.getStepStored().steps[Steps.customer]) === null || _e === void 0 ? void 0 : _e.paymentModeSelected) || { id: "", name: "", value: "" }), paymentModelSelected = _158[0], setPaymentModelSelected = _158[1];
    var _159 = React.useState(localStorageService.getStepStored().steps[Steps.customer].coverType), coverTypeSelected = _159[0], setCoverTypeSelected = _159[1];
    var _160 = useState(""), productType = _160[0], setProductType = _160[1];
    var projectTypeLocal = React.useRef((_g = (_f = lsSteps.getStepStored().steps[Steps.insurance].flow) === null || _f === void 0 ? void 0 : _f.metadata) === null || _g === void 0 ? void 0 : _g.navigation.productType);
    var didMountRef = React.useRef(false);
    var _161 = useState(""), quoteId = _161[0], setQuoteId = _161[1];
    var isApap = getCustomerAction().customerAuto.includes(company);
    var Quote = React.useState(findParamInLocalStorage("Quote"))[0];
    var quoteIdLS = Quote === null || Quote === void 0 ? void 0 : Quote.id;
    var summary = useGetSummary();
    var pathname = useLocation().pathname;
    var searchParams = useSearchParams()[0];
    var legacyQuoteId = (_h = searchParams.get("legacyId")) !== null && _h !== void 0 ? _h : "";
    var isLegacyQuote = Boolean(legacyQuoteId);
    var legacyBackRoute = resolveLegacyBackRoute(searchParams.get(CONFIRMATION_FORM_ORIGIN_PARAM));
    var showButtonActivatePolicy = !!activatePolicy && !isLegacyQuote;
    var _162 = useGetLegacyQuote({
        legacyId: legacyQuoteId,
        enable: isLegacyQuote,
        setSeeToast: setSeeToast,
        t: t,
    }), responseLegacyQuote = _162.responseLegacyQuote, loadingLegacyQuote = _162.loadingLegacyQuote, errorLegacyQuote = _162.errorLegacyQuote;
    var legacyPolicyCode = (_k = (_j = responseLegacyQuote === null || responseLegacyQuote === void 0 ? void 0 : responseLegacyQuote.policyId) === null || _j === void 0 ? void 0 : _j.code) !== null && _k !== void 0 ? _k : "";
    var _163 = useGetLegacyQuoteDetail({
        policyCode: legacyPolicyCode,
        enable: isLegacyQuote && !!legacyPolicyCode,
        setSeeToast: setSeeToast,
        t: t,
    }), responseLegacyQuoteDetail = _163.responseLegacyQuoteDetail, loadingLegacyQuoteDetail = _163.loadingLegacyQuoteDetail;
    var legacyQuoteData = useLegacyQuoteDataForm(responseLegacyQuote, responseLegacyQuoteDetail === null || responseLegacyQuoteDetail === void 0 ? void 0 : responseLegacyQuoteDetail.legacyDetail);
    var showRequestCertificatesButton = isLegacyQuote && !!((_l = legacyQuoteData === null || legacyQuoteData === void 0 ? void 0 : legacyQuoteData.dataForm) === null || _l === void 0 ? void 0 : _l.policeNumber);
    var certificatesConversion = useLegacyConversionRun(CERTIFICATES_CONVERSION_REQUEST_KEY);
    useEffect(function () {
        var outcome = certificatesConversion.outcome;
        if (!outcome)
            return;
        certificatesConversion.clearOutcome();
        if (outcome.kind === "completed" && outcome.route) {
            window.location.replace(outcome.route);
            return;
        }
        if (outcome.kind === "failed") {
            showErrorToast(outcome.error, setSeeToast, t, true);
            return;
        }
        var toast = runToastOf(outcome);
        if (toast)
            setSeeToast(__assign({ show: true }, toast));
    }, [certificatesConversion.outcome]);
    var pathLocation = "/" + pathname.split("/")[1];
    var _164 = React.useState({}), sessionData = _164[0], setSessionData = _164[1];
    var _165 = React.useState(false), triggerStart = _165[0], setTriggerStart = _165[1];
    var workFlow = localStorage.getItem("WorkFlowId");
    var _166 = useState(""), instanceIdR = _166[0], setInstanceIdR = _166[1];
    var _167 = useState(""), currentStepId = _167[0], setCurrentStepId = _167[1];
    var _168 = React.useState(""), email = _168[0], setEmail = _168[1];
    var _169 = useState(""), nextStepId = _169[0], setNextStepId = _169[1];
    // ✅ Flag para refrescar la información de los pasos
    var _170 = useState(0), refreshStepsInfo = _170[0], setRefreshStepsInfo = _170[1];
    var _171 = React.useState([]), referrerRows = _171[0], setReferrerRows = _171[1];
    var _172 = useStepNavigation({
        currentStepId: pathLocation,
        sessionData: sessionData,
        autoValidate: true,
    }), navigation = _172.navigation, isLastPage = _172.isLastPage;
    var showCardInformation = getFlagValue("afy-confirm-data-show-card-information");
    var showDocumentClient = useState(function () { return getFlagValue("afy-isVidaActiva"); })[0];
    // ✅ Ahora pasa el refreshTrigger para recargar cuando cambie
    var _173 = useGetInformationSteps(pathLocation, { refreshTrigger: refreshStepsInfo }), instanceId = _173.instanceId, workFlowId = _173.workFlowId, currentStep = _173.currentStep, nextStep = _173.nextStep;
    // Ref para controlar si ya se inicializó el país una vez
    var countryInitializedRef = React.useRef(false);
    var actionFlagsFound = findParamInLocalStorage("", "afy-action-flags");
    var flagFound = actionFlagsFound === null || actionFlagsFound === void 0 ? void 0 : actionFlagsFound.find(function (flag) { return flag.name === "afy-confirm-filter-insurances-by-plan"; });
    var flagFilterInsuranceTypeByPlan = (flagFound === null || flagFound === void 0 ? void 0 : flagFound.value) === "true";
    var shouldFilterByCoverType = coverTypeId === "43430f8b-8fe3-4582-8d11-6f9edf69bb9e" &&
        flagFilterInsuranceTypeByPlan;
    var planIdForCatalog = shouldFilterByCoverType ? planId : undefined;
    var _174 = useState([]), downloadsStatusDenyList = _174[0], setDownloadsStatusDenyList = _174[1];
    var _175 = useState([]), showTabPaymentStatusAllowList = _175[0], setShowTabPaymentStatusAllowList = _175[1];
    var _176 = useState(false), isThereTabPaymentStatusAllowList = _176[0], setIsThereShowTabPaymentStatusAllowList = _176[1];
    var showComments = true;
    var showLogsInfo = true;
    var showTabReferrer = (_m = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.some(function (f) {
        return f.name === "afy-confirm-data-show-tab-referrer" && f.value === "true";
    })) !== null && _m !== void 0 ? _m : false;
    var canChangePolicy = actionFlagsLoaded &&
        !(actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.some(function (f) { return f.name === "afy-do-not-change-policy" && f.value === "true"; }));
    var sendProductCode = (_o = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.some(function (f) {
        return f.name === "afy-confirm-send-productCode" && f.value === "true";
    })) !== null && _o !== void 0 ? _o : false;
    var _177 = React.useState([]), holidays = _177[0], setHolidays = _177[1];
    var _178 = React.useState(""), rolAsesorid = _178[0], setRolAsesorId = _178[1];
    var _179 = useSelectors(), loadingUpdateQuote = _179.loadingUpdateQuote, errorUpdateQuote = _179.errorUpdateQuote, responseIdentificationType = _179.responseIdentificationType, errorIdentificationType = _179.errorIdentificationType, responseCatalogGender = _179.responseCatalogGender, errorCatalogGender = _179.errorCatalogGender, responsePlan = _179.responsePlan, errorPlan = _179.errorPlan, loading = _179.loading, responseCountries = _179.responseCountries, errorCountries = _179.errorCountries, responseRegion = _179.responseRegion, errorRegion = _179.errorRegion, responsePlans = _179.responsePlans, errorPlans = _179.errorPlans, loadingPlans = _179.loadingPlans, responseInsured = _179.responseInsured, errorInsured = _179.errorInsured, responseDeleteInsured = _179.responseDeleteInsured, errorDeleteInsured = _179.errorDeleteInsured, loadingDeleteInsured = _179.loadingDeleteInsured, responsePostInsured = _179.responsePostInsured, errorPostInsured = _179.errorPostInsured, loadingPostInsured = _179.loadingPostInsured, responsePatchInsured = _179.responsePatchInsured, errorPatchInsured = _179.errorPatchInsured, loadingPatchInsured = _179.loadingPatchInsured, responseUpdatePerson = _179.responseUpdatePerson, errorUpdatePerson = _179.errorUpdatePerson, loadingUpdatePerson = _179.loadingUpdatePerson, responseBenefit = _179.responseBenefit, errorBenefit = _179.errorBenefit, loadingBenefit = _179.loadingBenefit, responsePatchBeneficiary = _179.responsePatchBeneficiary, errorPatchBeneficiary = _179.errorPatchBeneficiary, loadingPatchBeneficiary = _179.loadingPatchBeneficiary, responseBeneficiary = _179.responseBeneficiary, errorBeneficiary = _179.errorBeneficiary, loadingBeneficiary = _179.loadingBeneficiary, responsePageActionFlags = _179.responsePageActionFlags, responseOneProject = _179.responseOneProject, loadingOneProject = _179.loadingOneProject, errorOneQuote = _179.errorOneQuote, responseOneQuote = _179.responseOneQuote, loadingOneQuote = _179.loadingOneQuote, loadingInsured = _179.loadingInsured, responsePatchQuote = _179.responsePatchQuote, errorPatchQuote = _179.errorPatchQuote, loadingPatchQuote = _179.loadingPatchQuote, responsePolicyConfirmLoading = _179.responsePolicyConfirmLoading, responsePolicyConfirm = _179.responsePolicyConfirm, responsePolicyConfirmError = _179.responsePolicyConfirmError;
    var updateVehicle = useVehicle(setOpenModalEditVehicle).updateVehicle;
    var _180 = useClient(paymentMode, setPeriod, setPaymentModelSelected, setPaymentMode, paymentModelSelected, coverTypeSelected, plans, enable, page, limit, projectId, namePlan, clientId, setCoverTypeSelected, campaigns, setCampaignSelected, level2, level3, setListRegionLevel3, listGenders, setHideMarriedName, setCoverType, setPlan, campaignSelected, personQuoteId, hideMarriedName, salesFlow, setCampaign, setCampaigns, setFileName, setPdfFile, setUploadTrigger, actionFlags, isQuote, setShowInsured, setAddInsured, setShowBeneficiary, setAddBeneficiary, setCanEditInsured, setCanEditBeneficiary, responseOneQuote, setTriggerCertificate, setUrlDocument, setopenModalPdfViewer, catalogPaymentMode, setDataForm, setDefaultFilters, setPrime, dataForm, setShowNewFormInsurance, setShowTabRealEstates, setShowFormBusiness, setShowTabAppointment, setShowTabAppointmentManager, (_p = id !== null && id !== void 0 ? id : quoteId) !== null && _p !== void 0 ? _p : "", userId), searchPerson = _180.searchPerson, handleSearch = _180.handleSearch, callDispatchPlan = _180.callDispatchPlan, callDispatchPlanAfterQuoteLoaded = _180.callDispatchPlanAfterQuoteLoaded, handleOnChangePaymentMethod = _180.handleOnChangePaymentMethod, handleOnChangeCoverType = _180.handleOnChangeCoverType, handleOnChangeCampaign = _180.handleOnChangeCampaign, handleChangeSelect = _180.handleChangeSelect, handleChangeSelectFormInsurance = _180.handleChangeSelectFormInsurance, handleUpdatePerson = _180.handleUpdatePerson, handleDownload = _180.handleDownload, updateDataFormPerson = _180.updateDataFormPerson, setCoverTypeStorybook = _180.setCoverTypeStorybook, handleOnClickAcquire = _180.handleOnClickAcquire, quoteUploadDocuments = _180.quoteUploadDocuments, callQuoteOne = _180.callQuoteOne, getActionFlags = _180.getActionFlags, handleOnClickAutoDownload = _180.handleOnClickAutoDownload, handleOnClickAutoDownloadVida = _180.handleOnClickAutoDownloadVida, setLocalStorage = _180.setLocalStorage, callDispatchPageActionFlags = _180.callDispatchPageActionFlags, showVehicleData = _180.showVehicleData, showDownloadQuote = _180.showDownloadQuote, showDownloadRequest = _180.showDownloadRequest;
    var branchesData = useSelector(function (state) { var _a, _b; return (_b = (_a = state.Branches) === null || _a === void 0 ? void 0 : _a.responseBranches) === null || _b === void 0 ? void 0 : _b.data; });
    var loadingBranches = useSelector(function (state) { var _a; return (_a = state.Branches) === null || _a === void 0 ? void 0 : _a.loadingBranches; });
    useEffect(function () {
        if (clientId && !isLegacyQuote) {
            dispatch(Branches({
                enable: true,
                page: 1,
                limit: 100,
                clientId: clientId,
            }));
        }
    }, [clientId, isLegacyQuote, dispatch]);
    var branchSwitcherOptions = useMemo(function () {
        var _a;
        var mapBranch = function (b) { return ({
            id: b.id,
            name: "".concat(b.code, " - ").concat(b.name),
            value: b.id,
        }); };
        if (Array.isArray(branchesData) && branchesData.length > 0) {
            return branchesData.map(mapBranch);
        }
        var q = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data;
        var bd = q === null || q === void 0 ? void 0 : q.branchData;
        if ((q === null || q === void 0 ? void 0 : q.branch) && bd && (bd.name != null || bd.code != null)) {
            return [
                {
                    id: q.branch,
                    name: bd.code != null && bd.name
                        ? "".concat(bd.code, " - ").concat(bd.name)
                        : bd.name || String((_a = bd.code) !== null && _a !== void 0 ? _a : ""),
                    value: q.branch,
                },
            ];
        }
        return [];
    }, [branchesData, responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data]);
    var branchDisplayLabelForSwitcher = (_s = (_r = (_q = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _q === void 0 ? void 0 : _q.branchData) === null || _r === void 0 ? void 0 : _r.name) !== null && _s !== void 0 ? _s : "";
    var _181 = useMailHistory({
        policyId: policyId,
        setSeeToast: setSeeToast,
        t: t,
    }), mailHistoryItems = _181.mailHistoryItems, mailHistoryLogCertificate = _181.mailHistoryLogCertificate, loadingMailHistory = _181.loadingMailHistory, downloadMailHistory = _181.downloadMailHistory, refetchMailHistory = _181.refetchMailHistory;
    var mailHistoryCertificate = (_w = (_v = (_u = (_t = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _t === void 0 ? void 0 : _t.policyId) === null || _u === void 0 ? void 0 : _u.code) !== null && _v !== void 0 ? _v : mailHistoryLogCertificate) !== null && _w !== void 0 ? _w : "";
    var mailHistoryPrintedAt = formattedDateTime(new Date().toISOString());
    var handleBranchChange = useCallback(function (newBranchId) { return __awaiter(void 0, void 0, void 0, function () {
        var currentQuote, effectiveQuoteId, planIdBody, coverTypeIdBody, campaignIdBody, catalogPaymentModeBody, catalogStatusQuoteBody, _a;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    currentQuote = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data;
                    effectiveQuoteId = id !== null && id !== void 0 ? id : quoteId;
                    if (!currentQuote ||
                        !effectiveQuoteId ||
                        !userId ||
                        !((_b = currentQuote.catalogStatusQuote) === null || _b === void 0 ? void 0 : _b.id)) {
                        return [2 /*return*/];
                    }
                    planIdBody = (_c = currentQuote.planId) === null || _c === void 0 ? void 0 : _c.id;
                    coverTypeIdBody = (_d = currentQuote.coverType) === null || _d === void 0 ? void 0 : _d.id;
                    campaignIdBody = (_e = currentQuote.campaignId) === null || _e === void 0 ? void 0 : _e.id;
                    catalogPaymentModeBody = (_f = currentQuote.catalogPaymentMode) === null || _f === void 0 ? void 0 : _f.id;
                    catalogStatusQuoteBody = (_g = currentQuote.catalogStatusQuote) === null || _g === void 0 ? void 0 : _g.id;
                    if (!planIdBody ||
                        !coverTypeIdBody ||
                        !campaignIdBody ||
                        !catalogPaymentModeBody ||
                        !catalogStatusQuoteBody) {
                        return [2 /*return*/];
                    }
                    _h.label = 1;
                case 1:
                    _h.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, patchQuoteAPI({
                            planId: planIdBody,
                            coverTypeId: coverTypeIdBody,
                            campaignId: campaignIdBody,
                            catalogPaymentMode: catalogPaymentModeBody,
                            catalogStatusQuote: catalogStatusQuoteBody,
                            branchId: newBranchId,
                            userId: userId,
                        }, effectiveQuoteId)];
                case 2:
                    _h.sent();
                    callQuoteOne(effectiveQuoteId);
                    showToastSuccessMessage("Sucursal actualizada.", typeAlert.success, setSeeToast);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _h.sent();
                    showToastSuccessMessage("No se pudo cambiar la sucursal.", typeAlert.error, setSeeToast);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [responseOneQuote, id, quoteId, userId, callQuoteOne, setSeeToast]);
    var _182 = useInsurance(setTitleInsured, setIsUpdate, setOpenModal, setOpenModalAddInsurance, dataFormInsurance, setDataFormInsurance, dataFormInsuranceSp, setDataFormInsuranceSp, insuranceType, setRows, responseOneQuote, quoteId ? quoteId : id, clientId, personId, isUpdate, setIsMaskedDocument, setPersonId, listIdentificationType, insuredType, setIsInsurance, setDocument, setTrigger, showNewFormInsurance, setSeeToast), handleAddInsured = _182.handleAddInsured, setInsuranceStorybook = _182.setInsuranceStorybook, handleSubmitInsured = _182.handleSubmitInsured, editInsured = _182.editInsured, searchInsurancePerson = _182.searchInsurancePerson;
    var _183 = useBeneficiary(setIsUpdate, setInitialPercentage, setTitleBeneficiary, setOpenModalBeneficiary, dataFormBeneficiary, setDataFormBeneficiary, initialPercentage, responseOneQuote, clientId, isUpdate, setIsMaskedDocument, setPersonId, listIdentificationType), setBeneficiaryStorybook = _183.setBeneficiaryStorybook, handleAddBeneficiary = _183.handleAddBeneficiary, handleSubmitBeneficiary = _183.handleSubmitBeneficiary, getInsuredBeneficiary = _183.getInsuredBeneficiary, editBeneficiary = _183.editBeneficiary;
    var _184 = useActions(setOpenDrawerUpload, setPdfFile, setFileName, setIdDocumentClient, setModalDocumentClient, setUrlDocumentClient, setDocName, isVidaTermino, navigate, navigateNext, STEP, id, setOpenModalBackConfirm, isPlan, isDocumentClient, workFlowId, instanceId, currentStep, nextStep, currentStepId, nextStepId, pathLocation, navigation, sendProductCode, productCode, isLegacyQuote, legacyBackRoute), handleNext = _184.handleNext, handlePrevious = _184.handlePrevious, onClickBack = _184.onClickBack, handleCloseBackModal = _184.handleCloseBackModal, handleBackFromModal = _184.handleBackFromModal, handleClickContextMenu = _184.handleClickContextMenu, loadingComplete = _184.loadingComplete;
    var handleSendEmail = usePaymentConfirmation(policyId, dispatch, policyConfirm).handleSendEmail;
    var filterData = useFunctions().filterData;
    var _185 = useCertificateQuote(triggerCertificate, "cotizacion", quoteId, 1, 20), responseCertificateQuote = _185.responseCertificateQuote, errorCertificateQuote = _185.errorCertificateQuote, loadingCertificateQuote = _185.loadingCertificateQuote;
    var _186 = useCatalogues(propertyTypeId, !isLegacyQuote), loadingCatalogues = _186.loadingCatalogues, errorCatalogues = _186.errorCatalogues, businessType = _186.businessType, typeConstruction = _186.typeConstruction, businessShift = _186.businessShift;
    var _187 = PostUploadDocuments(uploadTrigger, id ? id : quoteId, fileName, pdfFile, idDocumentClient), responseUploadDocuments = _187.responseUploadDocuments, errorUploadDocuments = _187.errorUploadDocuments, loadingUploadDocuments = _187.loadingUploadDocuments;
    var _188 = GetCatalogBeneficiary(triggerCatalog, enable, page, limit, clientId), responseGetCatalogBeneficiary = _188.responseGetCatalogBeneficiary, errorGetCatalogBeneficiary = _188.errorGetCatalogBeneficiary, loadingGetCatalogBeneficiary = _188.loadingGetCatalogBeneficiary;
    var _189 = GetCatalogInsurance(triggerCatalogInsurance, enable, page, limit, clientId, planIdForCatalog), responseGetCatalogInsurance = _189.responseGetCatalogInsurance, errorGetCatalogInsurance = _189.errorGetCatalogInsurance, loadingGetCatalogInsurance = _189.loadingGetCatalogInsurance;
    var _190 = GetPersonByDocument(trigger, document), responsePersonByDocument = _190.responsePersonByDocument, errorPersonByDocument = _190.errorPersonByDocument, loadingPersonByDocument = _190.loadingPersonByDocument;
    var _191 = GetPaymentMode(triggerPaymentMode, projectId || idProject || ""), responsePaymentMode = _191.responsePaymentMode, errorPaymentMode = _191.errorPaymentMode, loadingPaymentMode = _191.loadingPaymentMode;
    useEffect(function () {
        if (!projectId)
            return;
        dispatch(projectOne({ id: projectId }));
        setTriggerPaymentMode(true);
    }, [projectId]);
    var onSameDirection = function (checked, data) {
        var _a;
        if (data === "sameAddress") {
            if (checked === true) {
                var addressFromQuote_1 = ((_a = responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.address1) || "";
                setDataFormBusiness(function (prev) { return ({
                    Province: provinceId,
                    Town: townId,
                    Sector: sectorId,
                    propertyAddress: addressFromQuote_1,
                }); });
            }
            else {
                setDataFormBusiness(function (prev) { return ({
                    Province: "",
                    Town: "",
                    Sector: "",
                    propertyAddress: "",
                }); });
            }
        }
    };
    var _192 = useStartWokFlow(triggerStart, workFlow !== null && workFlow !== void 0 ? workFlow : "", function () { return setTriggerStart(false); }), loadingStartWorkFlow = _192.loadingStartWorkFlow, responseStartWorkFlow = _192.responseStartWorkFlow, errorStartWorkflow = _192.errorStartWorkflow;
    useErrorHandling({
        errorPersonByDocument: errorPersonByDocument,
        errorOneQuote: errorOneQuote,
        errorInsured: errorInsured,
        errorCatalogGender: errorCatalogGender,
        errorCountries: errorCountries,
        errorRegion: errorRegion,
        errorUpdateQuote: errorUpdateQuote,
        errorPlan: errorPlan,
        errorBeneficiary: errorBeneficiary,
        errorIdentificationType: errorIdentificationType,
        errorUpdatePerson: errorUpdatePerson,
        errorPatchBeneficiary: errorPatchBeneficiary,
        errorPatchInsured: errorPatchInsured,
        errorBenefit: errorBenefit,
        errorPostInsured: errorPostInsured,
        errorPlans: errorPlans,
        errorUploadDocuments: errorUploadDocuments,
        errorPaymentMode: errorPaymentMode,
        errorCertificateQuote: errorCertificateQuote,
        errorStartWorkflow: errorStartWorkflow,
        errorPolicyConfirm: responsePolicyConfirmError,
        // Excluye al Titular: el límite del producto aplica a los asegurados
        // adicionales, no a la persona principal de la cotización.
        insuredCount: rows.filter(function (row) { var _a; return ((_a = row.type) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== "titular"; }).length,
        setSeeToast: setSeeToast,
    });
    useEffect(function () {
        if (isLegacyQuote) {
            setFilters(LEGACY_FILTERS_PLACEHOLDER);
        }
    }, [isLegacyQuote]);
    useEffect(function () {
        if (isLegacyQuote && legacyQuoteData) {
            setDataForm(legacyQuoteData.dataForm);
            setFilters(legacyQuoteData.filters);
            setRows(legacyQuoteData.insuredRows);
        }
    }, [isLegacyQuote, legacyQuoteData]);
    useEffect(function () {
        var _a;
        if (isLegacyQuote) {
            return;
        }
        dispatch(pageActionFlagsClearData());
        // Remove summary from localStorage if coming from insurancePoliciesSummary
        if (idProject) {
            localStorage.removeItem("summary");
        }
        setProjectTrigger(true);
        setTriggerCatalog(true);
        getActionFlags();
        if (!responseIdentificationType) {
            dispatch(identificationType({ enable: enable, page: page, limit: limit }));
        }
        if (!responseCountries) {
            dispatch(countries({ enable: enable, page: page, limit: limit }));
        }
        if (!(responseCatalogGender === null || responseCatalogGender === void 0 ? void 0 : responseCatalogGender.data)) {
            dispatch(catalogGender({ enable: enable, page: page, limit: limit }));
        }
        //Get Quote //
        var quoteIdLs = quoteIdLS;
        if (id !== undefined) {
            dispatch(quoteClearData());
            setCanEdit(isQuoteType);
            if (!isQuoteType) {
                setCanEditLocation(true);
                setCanEditContact(true);
            }
            //Get the quote by id
            callQuoteOne(id);
        }
        else {
            callQuoteOne(quoteIdLs);
        }
        callGetInsuredBeneficiary((_a = id !== null && id !== void 0 ? id : quoteIdLs) !== null && _a !== void 0 ? _a : "");
        // Note: callDispatchPlan moved to useEffect that waits for responseOneQuote
    }, []);
    useEffect(function () {
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        if (id !== undefined) {
            dispatch(quoteClearData());
            callQuoteOne(id);
        }
    }, [id]);
    // startFlow
    useEffect(function () {
        if (id !== undefined || isQuoteType) {
            setTriggerStart(true);
        }
    }, [workFlow]);
    useEffect(function () {
        var _a, _b;
        if (responseStartWorkFlow) {
            var nextStepId_1 = ((_a = responseStartWorkFlow.nextSteps[0]) === null || _a === void 0 ? void 0 : _a.nextSteps[0]) || "";
            setInstanceIdR(responseStartWorkFlow.instanceId);
            setCurrentStepId((_b = responseStartWorkFlow.currentStep) === null || _b === void 0 ? void 0 : _b.id);
            setNextStepId(nextStepId_1);
            localStorage.setItem("Quote", id !== null && id !== void 0 ? id : "");
            addStepInformationToAllSteps(workFlow !== null && workFlow !== void 0 ? workFlow : "", responseStartWorkFlow.instanceId);
            // Refrescar la información de los pasos después de actualizar localStorage
            setRefreshStepsInfo(function (prev) { return prev + 1; });
            dispatch(startWorkFlowClearData());
        }
    }, [responseStartWorkFlow]);
    //end startFlow
    useEffect(function () {
        var _a, _b, _c;
        if (responsePaymentMode && responsePaymentMode.length > 0) {
            // Transform payment mode response to select format
            var paymentModeList_1 = [];
            var quotePaymentModeId_1 = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.id;
            responsePaymentMode.map(function (item) {
                var _a, _b, _c, _d;
                var itemId = ((_a = item.catalogPaymentMode) === null || _a === void 0 ? void 0 : _a.id) || item.id;
                paymentModeList_1.push({
                    id: itemId,
                    name: ((_b = item.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description) || item.description || "",
                    value: ((_c = item.catalogPaymentMode) === null || _c === void 0 ? void 0 : _c.code) ||
                        ((_d = item.catalogPaymentMode) === null || _d === void 0 ? void 0 : _d.id) ||
                        item.id,
                    default: quotePaymentModeId_1 ? itemId === quotePaymentModeId_1 : false,
                });
            });
            setPaymentMode(paymentModeList_1);
            // Set initial payment mode selection only if not already set and no quote data available
            if (!(paymentModelSelected === null || paymentModelSelected === void 0 ? void 0 : paymentModelSelected.id) &&
                paymentModeList_1.length > 0 &&
                !((_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.catalogPaymentMode)) {
                setPaymentModelSelected(paymentModeList_1[0]);
                // Set initial period when payment mode is first loaded
                setPeriod(paymentModeList_1[0].name);
            }
        }
    }, [responsePaymentMode, (_y = (_x = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _x === void 0 ? void 0 : _x.catalogPaymentMode) === null || _y === void 0 ? void 0 : _y.id]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            setRowsPassengers((((_a = responseOneQuote.data.contentMap) === null || _a === void 0 ? void 0 : _a.additionalTravelers) || []).map(function (t) {
                var birthday = t.birthday || t.Birthday || "";
                var edad = "";
                if (birthday) {
                    var birth = new Date(birthday);
                    // Handle DD/MM/YYYY format
                    if (isNaN(birth.getTime())) {
                        var parts = birthday.split("/");
                        if (parts.length === 3) {
                            birth = new Date("".concat(parts[2], "-").concat(parts[1], "-").concat(parts[0]));
                        }
                    }
                    if (!isNaN(birth.getTime())) {
                        var today = new Date();
                        var age = today.getFullYear() - birth.getFullYear();
                        var m = today.getMonth() - birth.getMonth();
                        if (m < 0 || (m === 0 && today.getDate() < birth.getDate()))
                            age--;
                        edad = String(age);
                    }
                }
                return __assign(__assign({}, t), { birthday: birthday, edad: edad });
            }));
            var combustionMap = {
                GASOLINE: "Gasolina",
                DIESEL: "Diesel",
                ELECTRIC: "Eléctrico",
                GAS: "Gas",
            };
            var combustionType = (_b = responseOneQuote.data.contentMap) === null || _b === void 0 ? void 0 : _b.combustion;
            var carCombustion = combustionMap[combustionType] || "";
            var price = parsePrice(((_c = responseOneQuote.data.contentMap) === null || _c === void 0 ? void 0 : _c.deductibleTypeId) || 0);
            var newPrice = formatNumberCustom(price || 0);
            var car = {
                id: 1,
                brand: (_e = (_d = responseOneQuote.data.contentMap) === null || _d === void 0 ? void 0 : _d.brand) === null || _e === void 0 ? void 0 : _e.name,
                model: (_g = (_f = responseOneQuote.data.contentMap) === null || _f === void 0 ? void 0 : _f.model) === null || _g === void 0 ? void 0 : _g.name,
                fueltype: carCombustion,
                color: (_j = (_h = responseOneQuote.data.contentMap) === null || _h === void 0 ? void 0 : _h.colors) === null || _j === void 0 ? void 0 : _j.name,
                price: "RD$ ".concat(newPrice),
                cylinders: (_k = responseOneQuote.data.contentMap) === null || _k === void 0 ? void 0 : _k.cylinders,
                plate: (_l = responseOneQuote.data.contentMap) === null || _l === void 0 ? void 0 : _l.plate,
            };
            var vehicleDet = [];
            vehicleDet.push(car);
            setListVehicles(vehicleDet);
        }
    }, [responseOneQuote]);
    // Llenar datos de propiedad inmobiliaria
    useEffect(function () {
        var _a, _b, _c, _d;
        if (responseOneQuote && ((_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.contentMap)) {
            var contentMap_1 = responseOneQuote.data.contentMap;
            setPropertyTypeId(contentMap_1.propertyTypeId || "");
            setDamageBackup(formatToTwoDecimals(contentMap_1.damageBackup));
            setInsuredProperty(formatToTwoDecimals(contentMap_1.insuredProperty));
            setDataFormBusiness({
                ownerName: contentMap_1.ownerName,
                ownerIdNumber: contentMap_1.ownerIdNumber,
                propertyTypeId: contentMap_1.propertyTypeId,
                businessShift: contentMap_1.businessShift,
                sameAddress: contentMap_1.sameAddress,
                Province: contentMap_1.province,
                Town: contentMap_1.town,
                Sector: contentMap_1.sector,
                typeConstruction: contentMap_1.typeConstruction,
                propertyAddress: contentMap_1.propertyAddress,
                coverageNotes: contentMap_1.coverageNotes,
                typeProperty: contentMap_1.typeProperty,
                buildingValue: formatToTwoDecimals(contentMap_1.buildingValue),
                merchandiseValue: formatToTwoDecimals(contentMap_1.merchandiseValue),
                furnitureValue: formatToTwoDecimals(contentMap_1.furnitureValue),
                totalInsuredValue: formatToTwoDecimals(contentMap_1.transitValue),
            });
            if (contentMap_1.ownerName ||
                contentMap_1.businessShift ||
                contentMap_1.typeConstruction ||
                contentMap_1.propertyTypeId ||
                contentMap_1.address ||
                contentMap_1.constructionTypeName) {
                var businessTypeName = ((_b = businessType.find(function (item) { return item.id === contentMap_1.propertyTypeId; })) === null || _b === void 0 ? void 0 : _b.name) ||
                    contentMap_1.propertyTypeId ||
                    "";
                var businessShiftName = ((_c = businessShift.find(function (item) { return item.id === contentMap_1.businessShift; })) === null || _c === void 0 ? void 0 : _c.name) ||
                    contentMap_1.businessShift ||
                    "";
                var typeConstructionName = ((_d = typeConstruction.find(function (item) { return item.id === contentMap_1.typeConstruction; })) === null || _d === void 0 ? void 0 : _d.name) ||
                    contentMap_1.typeConstruction ||
                    "";
                var propertyData = {
                    id: 1,
                    ownerName: contentMap_1.ownerName || "",
                    propertyTypeId: businessTypeName,
                    businessShift: businessShiftName,
                    typeConstruction: typeConstructionName,
                    typeConstructionName: contentMap_1.constructionTypeName || "",
                    propertyAddress: contentMap_1.address || "",
                };
                setRowsProperties([propertyData]);
            }
        }
    }, [responseOneQuote, businessType, businessShift, typeConstruction]);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (responseCertificateQuote && ((_a = responseCertificateQuote.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var urlC = (_b = responseCertificateQuote.data[0]) === null || _b === void 0 ? void 0 : _b.url;
            if (urlC) {
                setUrlDocument(urlC);
                setNameDocument((_c = responseCertificateQuote.data[0]) === null || _c === void 0 ? void 0 : _c.title);
                setopenModalPdfViewer(true);
            }
            setTriggerCertificate(false);
            dispatch(certificateQuoteClearData());
        }
        else if (responseCertificateQuote &&
            ((_d = responseCertificateQuote.data) === null || _d === void 0 ? void 0 : _d.length) === 0) {
            setTriggerCertificate(false);
            showToastSuccessMessage("No se encontro ningun documento adjunto.", typeAlert.warning, setSeeToast);
            dispatch(certificateQuoteClearData());
        }
    }, [responseCertificateQuote]);
    // determina con que servicio iniciar el formulario de negocio
    useEffect(function () {
        if (planName) {
            var isCommerceValue_1 = planName.toLowerCase().includes("comercio");
            setIsCommerce(isCommerceValue_1);
            setDataFormBusiness(function (prev) { return (__assign(__assign({}, prev), { propertyTypeId: isCommerceValue_1 ? "1" : "2" })); });
        }
    }, [planName]);
    useEffect(function () {
        // Solo setear el país una vez cuando listCountries se cargue por primera vez
        if (listCountries.length > 0 && !countryInitializedRef.current) {
            var countryId_1 = getLogin().countryId || "";
            if (countryId_1) {
                setDataFormInsuranceSp(function (prev) { return (__assign(__assign({}, prev), { country: countryId_1 })); });
                countryInitializedRef.current = true;
            }
        }
    }, [listCountries]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97, _98, _99, _100, _101, _102, _103, _104, _105, _106, _107, _108, _109, _110, _111, _112, _113, _114, _115, _116, _117, _118, _119, _120, _121, _122, _123, _124, _125, _126, _127, _128, _129, _130, _131, _132, _133, _134, _135, _136, _137, _138, _139, _140, _141, _142, _143, _144, _145, _146, _147, _148, _149, _150, _151, _152, _153, _154, _155, _156, _157, _158, _159, _160, _161, _162, _163, _164, _165, _166, _167, _168, _169, _170, _171, _172, _173, _174, _175, _176, _177, _178, _179, _180, _181, _182, _183, _184, _185, _186, _187, _188, _189, _190, _191, _192, _193, _194, _195, _196, _197, _198, _199, _200, _201, _202, _203, _204, _205, _206, _207, _208, _209, _210, _211, _212, _213, _214, _215, _216, _217, _218, _219, _220, _221, _222, _223, _224, _225, _226, _227, _228, _229, _230, _231, _232, _233, _234, _235, _236;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            setProvinceId((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.province) === null || _b === void 0 ? void 0 : _b.id);
            setTowId((_d = (_c = responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.municipality) === null || _d === void 0 ? void 0 : _d.id);
            setSectorId((_f = (_e = responseOneQuote.data) === null || _e === void 0 ? void 0 : _e.district) === null || _f === void 0 ? void 0 : _f.id);
            setPlanCode(((_g = responseOneQuote.data) === null || _g === void 0 ? void 0 : _g.planId.code) || "");
            setProductCode(((_j = (_h = responseOneQuote.data) === null || _h === void 0 ? void 0 : _h.productId) === null || _j === void 0 ? void 0 : _j.code) || "");
            setPersonQuoteId((_k = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _k === void 0 ? void 0 : _k.personId);
            setQuoteId((_l = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _l === void 0 ? void 0 : _l.id);
            setPlanId((_o = (_m = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _m === void 0 ? void 0 : _m.planId) === null || _o === void 0 ? void 0 : _o.id);
            if ((_q = (_p = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _p === void 0 ? void 0 : _p.planId) === null || _q === void 0 ? void 0 : _q.projectId) {
                setProjectId(responseOneQuote.data.planId.projectId);
            }
            setCoverTypeId((_s = (_r = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _r === void 0 ? void 0 : _r.coverType) === null || _s === void 0 ? void 0 : _s.id);
            setTriggerCatalogInsurance(true);
            setCampaignId((_u = (_t = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _t === void 0 ? void 0 : _t.campaignId) === null || _u === void 0 ? void 0 : _u.id);
            setCatalogPaymentMode((_w = (_v = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _v === void 0 ? void 0 : _v.catalogPaymentMode) === null || _w === void 0 ? void 0 : _w.id);
            setEmail((_y = (responseOneQuote && ((_x = responseOneQuote.data) === null || _x === void 0 ? void 0 : _x.email))) !== null && _y !== void 0 ? _y : "");
            var currentStatusQuote = (_0 = (_z = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _z === void 0 ? void 0 : _z.catalogStatusQuote) === null || _0 === void 0 ? void 0 : _0.description;
            setPlan({
                id: (_2 = (_1 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _1 === void 0 ? void 0 : _1.planId) === null || _2 === void 0 ? void 0 : _2.id,
                name: (_4 = (_3 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _3 === void 0 ? void 0 : _3.planId) === null || _4 === void 0 ? void 0 : _4.name,
            });
            var quoteStatus_1 = currentStatusQuote === null || currentStatusQuote === void 0 ? void 0 : currentStatusQuote.toLowerCase();
            // Logica para mostrar o no los ducumentos de descarga
            var shouldShowDownloads = (function () {
                var _a;
                //If quote status Deny List exist evaulate list first
                if (downloadsStatusDenyList.length > 0 &&
                    !downloadsStatusDenyList.includes(quoteStatus_1)) {
                    // Prevent duplicate loading:
                    // - If id exists → skip
                    // - If id doesn't exist but there is a deny list then setCertificates
                    if (!id) {
                        var certs = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.certificates;
                        //Get the certificates
                        if (certs.length > 0) {
                            certs = certs.map(function (c, id) {
                                return {
                                    id: c.id,
                                    name: c.title,
                                    url: c.url,
                                };
                            });
                        }
                        setCertificates(certs);
                    }
                    return true;
                }
                // en el flujo de venta nuca se muestra
                if (id === undefined || isQuoteType)
                    return false;
                if (downloadsStatusDenyList.length > 0 &&
                    !downloadsStatusDenyList.includes(quoteStatus_1)) {
                    return true;
                }
                // Emitida siempre se muestra
                if (quoteStatus_1 === "emitida")
                    return true;
                // Cotizada no se muestra
                if (quoteStatus_1 === "cotizada")
                    return false;
                // Cancelada solo es es acap no se muestra
                if (quoteStatus_1 === "cancelada")
                    return !isAcapCompany;
                return false;
            })();
            //Set show payment tab by quote status if actionflag exist
            setHideTabPaymentInfo(!(isQuote === "false"));
            if (isThereTabPaymentStatusAllowList) {
                if (showTabPaymentStatusAllowList.includes(quoteStatus_1)) {
                    setHideTabPaymentInfo(false);
                }
                else {
                    setHideTabPaymentInfo(true);
                }
            }
            setShowDownloads(shouldShowDownloads);
            setPolicyId((_6 = (_5 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _5 === void 0 ? void 0 : _5.policyId) === null || _6 === void 0 ? void 0 : _6.id);
            setPolicyStatus((_10 = (_9 = (_8 = (_7 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _7 === void 0 ? void 0 : _7.policyId) === null || _8 === void 0 ? void 0 : _8.policyStatus) === null || _9 === void 0 ? void 0 : _9.description) !== null && _10 !== void 0 ? _10 : "");
            var pmData = (_11 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _11 === void 0 ? void 0 : _11.customerAccount;
            if (pmData) {
                var accountType = (_13 = (_12 = pmData === null || pmData === void 0 ? void 0 : pmData.accountType) === null || _12 === void 0 ? void 0 : _12.description) !== null && _13 !== void 0 ? _13 : "";
                setPaymentMethodCardData([
                    { name: "Tipo de cuenta", type: "label", label: accountType },
                    {
                        name: "Número de tarjeta / cuenta",
                        type: "label",
                        label: (_14 = pmData.accountNumber) !== null && _14 !== void 0 ? _14 : "",
                        showChangeButton: true,
                    },
                ]);
            }
            // INSURED CARD INFO
            var currencySymbol = ((_16 = (_15 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _15 === void 0 ? void 0 : _15.lastPrice) === null || _16 === void 0 ? void 0 : _16.currencySymbol) || "";
            var amount = (_19 = (_18 = (_17 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _17 === void 0 ? void 0 : _17.additionalDataMap) === null || _18 === void 0 ? void 0 : _18.coverageAmount) !== null && _19 !== void 0 ? _19 : "0.00";
            setRowsCardInfo([
                {
                    accountNumber: (_22 = (_21 = (_20 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _20 === void 0 ? void 0 : _20.additionalDataMap) === null || _21 === void 0 ? void 0 : _21.numberCard) !== null && _22 !== void 0 ? _22 : "",
                    revolvingLimit: "".concat(currencySymbol, " ").concat(formatToTwoDecimals(amount)),
                },
            ]);
            // END INSURED CARD INFO
            // Update paymentModelSelected with the catalogPaymentMode from quote
            if ((_23 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _23 === void 0 ? void 0 : _23.catalogPaymentMode) {
                var selectedPaymentMode = {
                    id: responseOneQuote.data.catalogPaymentMode.id,
                    name: responseOneQuote.data.catalogPaymentMode.description,
                    value: responseOneQuote.data.catalogPaymentMode.code ||
                        responseOneQuote.data.catalogPaymentMode.id,
                    label: responseOneQuote.data.catalogPaymentMode.description,
                };
                setPaymentModelSelected(selectedPaymentMode);
                // Set period from quote data
                setPeriod(responseOneQuote.data.catalogPaymentMode.description);
                // Update paymentMode array to mark the correct option as default
                if (paymentMode.length > 0) {
                    var updatedPaymentMode = paymentMode.map(function (mode) { return (__assign(__assign({}, mode), { default: mode.id === responseOneQuote.data.catalogPaymentMode.id })); });
                    setPaymentMode(updatedPaymentMode);
                }
            }
            setCatalogStatusQuote((_25 = (_24 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _24 === void 0 ? void 0 : _24.catalogStatusQuote) === null || _25 === void 0 ? void 0 : _25.id);
            var statusDescription = (_28 = (_27 = (_26 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _26 === void 0 ? void 0 : _26.catalogStatusQuote) === null || _27 === void 0 ? void 0 : _27.description) === null || _28 === void 0 ? void 0 : _28.toLowerCase();
            setAddAppointmentAction(statusDescription !== "ganada");
            setBranchId((_29 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _29 === void 0 ? void 0 : _29.branch);
            setPlanName((_31 = (_30 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _30 === void 0 ? void 0 : _30.planId) === null || _31 === void 0 ? void 0 : _31.name);
            // getInsuredBeneficiary();
            var gender = listGenders.find(function (g) { var _a, _b; return g.id === ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogGender) === null || _b === void 0 ? void 0 : _b.id); });
            var HideMarriedName = (gender === null || gender === void 0 ? void 0 : gender.name) === "Femenino" ? false : true;
            setHideMarriedName(HideMarriedName);
            /*date = formattedDate(date);*/
            //Province
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level1,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            //Municipality
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level2,
                parentRegionId: (_33 = (_32 = responseOneQuote.data) === null || _32 === void 0 ? void 0 : _32.municipality) === null || _33 === void 0 ? void 0 : _33.parentRegionId,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            //District
            dispatch(region({
                enable: enable,
                page: page,
                limit: limit,
                level: level3,
                parentRegionId: (_35 = (_34 = responseOneQuote.data) === null || _34 === void 0 ? void 0 : _34.district) === null || _35 === void 0 ? void 0 : _35.parentRegionId,
                clientId: lsLogin.getUserLoginStored().clientId,
            }));
            var status = (_37 = (_36 = responseOneQuote.data) === null || _36 === void 0 ? void 0 : _36.catalogStatusQuote) === null || _37 === void 0 ? void 0 : _37.description;
            if (status == "Cancelada") {
                status = "Fecha de cancelación";
            }
            else if (status == "Emitida") {
                status = "Fecha de emisión";
            }
            else if (status == "Expirada") {
                status = "Fecha de expiración";
            }
            else {
                status = "Fecha de cotización";
            }
            var date = ((_39 = (_38 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _38 === void 0 ? void 0 : _38.policyId) === null || _39 === void 0 ? void 0 : _39.effectiveFrom) ||
                ((_40 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _40 === void 0 ? void 0 : _40.creationDate);
            var nextYearDate = undefined;
            var originalDate = void 0;
            if (date) {
                var originalDate_1 = new Date(date);
                originalDate_1.setFullYear(originalDate_1.getFullYear() + 1);
                nextYearDate = formattedDate(originalDate_1.toISOString());
                nextYearDate = originalDate_1.toISOString();
            }
            setDataForm({
                DocumentNumber: formatDocument(responseOneQuote && ((_41 = responseOneQuote.data) === null || _41 === void 0 ? void 0 : _41.numberId)),
                IdType: ((_43 = (_42 = responseOneQuote.data) === null || _42 === void 0 ? void 0 : _42.identificationTypeId) === null || _43 === void 0 ? void 0 : _43.id)
                    ? (_45 = (_44 = responseOneQuote.data) === null || _44 === void 0 ? void 0 : _44.identificationTypeId) === null || _45 === void 0 ? void 0 : _45.id
                    : "",
                Type: responseOneQuote &&
                    ((_47 = (_46 = responseOneQuote.data) === null || _46 === void 0 ? void 0 : _46.identificationTypeId) === null || _47 === void 0 ? void 0 : _47.description),
                QuoteNumber: responseOneQuote && ((_48 = responseOneQuote.data) === null || _48 === void 0 ? void 0 : _48.code),
                policeNumber: ((_49 = responseOneQuote.data) === null || _49 === void 0 ? void 0 : _49.policyId)
                    ? (_50 = responseOneQuote.data) === null || _50 === void 0 ? void 0 : _50.policyId.code
                    : "",
                Name: responseOneQuote && ((_51 = responseOneQuote.data) === null || _51 === void 0 ? void 0 : _51.firstNameA),
                SecondName: responseOneQuote && ((_52 = responseOneQuote.data) === null || _52 === void 0 ? void 0 : _52.firstNameB),
                FirstLastName: responseOneQuote && ((_53 = responseOneQuote.data) === null || _53 === void 0 ? void 0 : _53.lastNameA),
                SecondLastName: responseOneQuote && ((_54 = responseOneQuote.data) === null || _54 === void 0 ? void 0 : _54.lastNameB),
                MarriedSurName: responseOneQuote && ((_55 = responseOneQuote.data) === null || _55 === void 0 ? void 0 : _55.marriedName),
                Birthday: responseOneQuote && ((_56 = responseOneQuote.data) === null || _56 === void 0 ? void 0 : _56.dob),
                Address1: responseOneQuote && ((_57 = responseOneQuote.data) === null || _57 === void 0 ? void 0 : _57.address1),
                Address2: responseOneQuote && ((_58 = responseOneQuote.data) === null || _58 === void 0 ? void 0 : _58.address2),
                PhoneOffice: responseOneQuote && formatPhoneNumber((_59 = responseOneQuote.data) === null || _59 === void 0 ? void 0 : _59.phone2),
                PhoneHome: responseOneQuote && formatPhoneNumber((_60 = responseOneQuote.data) === null || _60 === void 0 ? void 0 : _60.phone1),
                PhoneNumber: responseOneQuote && formatPhoneNumber((_61 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _61 === void 0 ? void 0 : _61.phone3),
                Email: responseOneQuote && ((_62 = responseOneQuote.data) === null || _62 === void 0 ? void 0 : _62.email),
                QuoteStatusName: responseOneQuote &&
                    ((_64 = (_63 = responseOneQuote.data) === null || _63 === void 0 ? void 0 : _63.catalogStatusQuote) === null || _64 === void 0 ? void 0 : _64.description),
                QuoteDate: isApapAuto
                    ? ((_65 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _65 === void 0 ? void 0 : _65.policyId)
                        ? formattedDate(date)
                        : formattedDateTime(date)
                    : formattedDate(date),
                effectiveDate: responseOneQuote && ((_66 = responseOneQuote.data) === null || _66 === void 0 ? void 0 : _66.policyId)
                    ? nextYearDate
                    : "",
                PlanTypeName: responseOneQuote && ((_68 = (_67 = responseOneQuote.data) === null || _67 === void 0 ? void 0 : _67.planId) === null || _68 === void 0 ? void 0 : _68.name),
                CampaignName: responseOneQuote && ((_70 = (_69 = responseOneQuote.data) === null || _69 === void 0 ? void 0 : _69.campaignId) === null || _70 === void 0 ? void 0 : _70.name),
                IdTypeName: responseOneQuote &&
                    ((_72 = (_71 = responseOneQuote.data) === null || _71 === void 0 ? void 0 : _71.identificationTypeId) === null || _72 === void 0 ? void 0 : _72.description),
                Gender: responseOneQuote && ((_74 = (_73 = responseOneQuote.data) === null || _73 === void 0 ? void 0 : _73.catalogGender) === null || _74 === void 0 ? void 0 : _74.id),
                Country: responseOneQuote && ((_76 = (_75 = responseOneQuote.data) === null || _75 === void 0 ? void 0 : _75.nationality) === null || _76 === void 0 ? void 0 : _76.id),
                CountryName: responseOneQuote && ((_78 = (_77 = responseOneQuote.data) === null || _77 === void 0 ? void 0 : _77.nationality) === null || _78 === void 0 ? void 0 : _78.name),
                Province: responseOneQuote && ((_80 = (_79 = responseOneQuote.data) === null || _79 === void 0 ? void 0 : _79.province) === null || _80 === void 0 ? void 0 : _80.id),
                ProvinceName: responseOneQuote && ((_82 = (_81 = responseOneQuote.data) === null || _81 === void 0 ? void 0 : _81.province) === null || _82 === void 0 ? void 0 : _82.name),
                TownName: responseOneQuote && ((_84 = (_83 = responseOneQuote.data) === null || _83 === void 0 ? void 0 : _83.municipality) === null || _84 === void 0 ? void 0 : _84.name),
                Town: responseOneQuote && ((_86 = (_85 = responseOneQuote.data) === null || _85 === void 0 ? void 0 : _85.municipality) === null || _86 === void 0 ? void 0 : _86.id),
                Sector: responseOneQuote && ((_88 = (_87 = responseOneQuote.data) === null || _87 === void 0 ? void 0 : _87.district) === null || _88 === void 0 ? void 0 : _88.id),
                SectorName: responseOneQuote && ((_90 = (_89 = responseOneQuote.data) === null || _89 === void 0 ? void 0 : _89.district) === null || _90 === void 0 ? void 0 : _90.name),
                PostalCode: responseOneQuote && ((_91 = responseOneQuote.data) === null || _91 === void 0 ? void 0 : _91.zip),
            });
            //setFormVehicle
            setIdQuoteVehicle((_93 = (_92 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _92 === void 0 ? void 0 : _92.contentMap) === null || _93 === void 0 ? void 0 : _93.idquoteVehicle);
            setProductId((_95 = (_94 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _94 === void 0 ? void 0 : _94.productId) === null || _95 === void 0 ? void 0 : _95.id);
            var carConditionName = void 0;
            switch ((_97 = (_96 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _96 === void 0 ? void 0 : _96.contentMap) === null || _97 === void 0 ? void 0 : _97.condition) {
                case "USED":
                    carConditionName = "Usado";
                    break;
                case "NEW":
                    carConditionName = "Nuevo";
                    break;
            }
            if ((_98 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _98 === void 0 ? void 0 : _98.profileDocuments) {
                var isCancelledQuote_1 = ((_101 = (_100 = (_99 = responseOneQuote.data) === null || _99 === void 0 ? void 0 : _99.catalogStatusQuote) === null || _100 === void 0 ? void 0 : _100.description) === null || _101 === void 0 ? void 0 : _101.toLowerCase()) ===
                    "cancelada";
                var pendingCount = responseOneQuote.data.profileDocuments.filter(function (doc) { return (doc === null || doc === void 0 ? void 0 : doc.status) === "PENDING" && (doc === null || doc === void 0 ? void 0 : doc.required) === true; }).length;
                setCountBadge(pendingCount);
                var dataRows = (_103 = (_102 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _102 === void 0 ? void 0 : _102.profileDocuments) === null || _103 === void 0 ? void 0 : _103.slice().sort(function (a, b) { return (b.required ? 1 : 0) - (a.required ? 1 : 0); }).filter(function (item) {
                    var _a;
                    if (!isCancelledQuote_1) {
                        return !((_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes("cancelaci"));
                    }
                    return true;
                }).map(function (item) {
                    var _a;
                    return ({
                        id: item.id,
                        docType: item.name,
                        mandatory: item.required === true ? "Requerido" : "Opcional",
                        state: (function () {
                            switch (item.status) {
                                case "PENDING":
                                    return "Pendiente";
                                case "READY":
                                    return "Listo";
                            }
                        })(),
                        required: item.required,
                        date: "",
                        user: "",
                        documentClientUrl: ((_a = item.document) === null || _a === void 0 ? void 0 : _a.path) || "",
                    });
                });
                setProfileDocumentsRows(dataRows);
            }
            var fuelTypeName = void 0;
            switch ((_105 = (_104 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _104 === void 0 ? void 0 : _104.contentMap) === null || _105 === void 0 ? void 0 : _105.combustion) {
                case "GAS":
                    fuelTypeName = "Gas";
                    break;
                case "ELECTRIC":
                    fuelTypeName = "Eléctrico";
                    break;
                case "DIESEL":
                    fuelTypeName = "Diesel";
                    break;
                case "GASOLINE":
                    fuelTypeName = "Gasolina";
                    break;
            }
            var countChassis = ((_107 = (_106 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _106 === void 0 ? void 0 : _106.contentMap) === null || _107 === void 0 ? void 0 : _107.chassisNumber) || "";
            var isChassisValid = (countChassis === null || countChassis === void 0 ? void 0 : countChassis.length) !== 17;
            setDataFormVehicle({
                carDetails: [
                    {
                        brand: {
                            id: (_110 = (_109 = (_108 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _108 === void 0 ? void 0 : _108.contentMap) === null || _109 === void 0 ? void 0 : _109.brand) === null || _110 === void 0 ? void 0 : _110.id,
                            name: (_113 = (_112 = (_111 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _111 === void 0 ? void 0 : _111.contentMap) === null || _112 === void 0 ? void 0 : _112.brand) === null || _113 === void 0 ? void 0 : _113.name,
                        },
                        model: {
                            id: (_116 = (_115 = (_114 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _114 === void 0 ? void 0 : _114.contentMap) === null || _115 === void 0 ? void 0 : _115.model) === null || _116 === void 0 ? void 0 : _116.id,
                            name: (_119 = (_118 = (_117 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _117 === void 0 ? void 0 : _117.contentMap) === null || _118 === void 0 ? void 0 : _118.model) === null || _119 === void 0 ? void 0 : _119.name,
                        },
                        version: {
                            id: (_122 = (_121 = (_120 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _120 === void 0 ? void 0 : _120.contentMap) === null || _121 === void 0 ? void 0 : _121.version) === null || _122 === void 0 ? void 0 : _122.id,
                            name: (_125 = (_124 = (_123 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _123 === void 0 ? void 0 : _123.contentMap) === null || _124 === void 0 ? void 0 : _124.version) === null || _125 === void 0 ? void 0 : _125.name,
                        },
                        class: {
                            id: (_128 = (_127 = (_126 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _126 === void 0 ? void 0 : _126.contentMap) === null || _127 === void 0 ? void 0 : _127.class) === null || _128 === void 0 ? void 0 : _128.id,
                            name: (_131 = (_130 = (_129 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _129 === void 0 ? void 0 : _129.contentMap) === null || _130 === void 0 ? void 0 : _130.class) === null || _131 === void 0 ? void 0 : _131.name,
                        },
                        type: {
                            id: (_134 = (_133 = (_132 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _132 === void 0 ? void 0 : _132.contentMap) === null || _133 === void 0 ? void 0 : _133.type) === null || _134 === void 0 ? void 0 : _134.id,
                            name: (_137 = (_136 = (_135 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _135 === void 0 ? void 0 : _135.contentMap) === null || _136 === void 0 ? void 0 : _136.type) === null || _137 === void 0 ? void 0 : _137.name,
                        },
                        weight: (_139 = (_138 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _138 === void 0 ? void 0 : _138.contentMap) === null || _139 === void 0 ? void 0 : _139.weight,
                        tonnage: (_141 = (_140 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _140 === void 0 ? void 0 : _140.contentMap) === null || _141 === void 0 ? void 0 : _141.tonnage,
                        passengerCant: (_143 = (_142 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _142 === void 0 ? void 0 : _142.contentMap) === null || _143 === void 0 ? void 0 : _143.passengerCant,
                    },
                ],
                year: (_145 = (_144 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _144 === void 0 ? void 0 : _144.contentMap) === null || _145 === void 0 ? void 0 : _145.year,
                carColor: [
                    {
                        id: (_148 = (_147 = (_146 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _146 === void 0 ? void 0 : _146.contentMap) === null || _147 === void 0 ? void 0 : _147.colors) === null || _148 === void 0 ? void 0 : _148.id,
                        name: (_151 = (_150 = (_149 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _149 === void 0 ? void 0 : _149.contentMap) === null || _150 === void 0 ? void 0 : _150.colors) === null || _151 === void 0 ? void 0 : _151.name,
                    },
                ],
                chassisNumber: (_153 = (_152 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _152 === void 0 ? void 0 : _152.contentMap) === null || _153 === void 0 ? void 0 : _153.chassisNumber,
                shortChassis: isChassisValid,
                price: (_155 = (_154 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _154 === void 0 ? void 0 : _154.contentMap) === null || _155 === void 0 ? void 0 : _155.deductibleTypeId,
                numberCylinders: [
                    {
                        id: (_157 = (_156 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _156 === void 0 ? void 0 : _156.contentMap) === null || _157 === void 0 ? void 0 : _157.cylinders,
                        name: (_159 = (_158 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _158 === void 0 ? void 0 : _158.contentMap) === null || _159 === void 0 ? void 0 : _159.cylinders,
                    },
                ],
                fuelType: [
                    {
                        id: (_161 = (_160 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _160 === void 0 ? void 0 : _160.contentMap) === null || _161 === void 0 ? void 0 : _161.combustion,
                        name: fuelTypeName,
                    },
                ],
                registrationNumber: (_163 = (_162 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _162 === void 0 ? void 0 : _162.contentMap) === null || _163 === void 0 ? void 0 : _163.plate,
                carCondition: [
                    {
                        id: (_165 = (_164 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _164 === void 0 ? void 0 : _164.contentMap) === null || _165 === void 0 ? void 0 : _165.condition,
                        name: carConditionName,
                    },
                ],
            });
            //EndFormVehicle
            //setStatementRows
            if (responseOneQuote.data.billing) {
                var sortedBilling = __spreadArray([], responseOneQuote.data.billing, true).sort(function (a, b) {
                    return new Date(a.dateExpire).getTime() - new Date(b.dateExpire).getTime();
                });
                var dataRows = sortedBilling.map(function (item) { return ({
                    reference: item.reference,
                    amount: "RD$ ".concat(item.amount),
                    paymentDate: newFormattedDate(item.paymentDate),
                    dateExpire: newFormattedDate(item.dateExpire),
                    datePaid: newFormattedDate(item.datePaid),
                    state: (function () {
                        switch (item.statusBilling) {
                            case "GENERATED":
                                return "Generado";
                            case "EMMITED":
                                return "Emitido";
                            case "PAID":
                                return "Pagado";
                            case "CANCELLED":
                                return "Cancelado";
                        }
                    })(),
                }); });
                setStatementRows(dataRows);
            }
            // EndSetStatmentRows
            // if (id) {
            // setPrime(responseOneQuote?.data?.lastPrice?.amount);
            setPrime(((_167 = (_166 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _166 === void 0 ? void 0 : _166.lastPrice) === null || _167 === void 0 ? void 0 : _167.currencySymbol) &&
                ((_169 = (_168 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _168 === void 0 ? void 0 : _168.lastPrice) === null || _169 === void 0 ? void 0 : _169.amount)
                ? "".concat(afy_currency !== null && afy_currency !== void 0 ? afy_currency : (_171 = (_170 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _170 === void 0 ? void 0 : _170.lastPrice) === null || _171 === void 0 ? void 0 : _171.currencySymbol, " ").concat(formatToTwoDecimals((_173 = (_172 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _172 === void 0 ? void 0 : _172.lastPrice) === null || _173 === void 0 ? void 0 : _173.amount))
                : "0.00");
            callDispatchPageActionFlags((_175 = (_174 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _174 === void 0 ? void 0 : _174.planId) === null || _175 === void 0 ? void 0 : _175.projectId);
            var campaignData = {
                id: (_177 = (_176 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _176 === void 0 ? void 0 : _176.campaignId) === null || _177 === void 0 ? void 0 : _177.id,
                name: (_179 = (_178 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _178 === void 0 ? void 0 : _178.campaignId) === null || _179 === void 0 ? void 0 : _179.name,
                value: (_181 = (_180 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _180 === void 0 ? void 0 : _180.campaignId) === null || _181 === void 0 ? void 0 : _181.id,
            };
            setCampaignSelected(campaignData);
            if (id) {
                if (isQuote === "false") {
                    setBreadCrumbs([]);
                }
                else {
                    setBreadCrumbs(stepProgress(STEP, true));
                }
                var certs = (_182 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _182 === void 0 ? void 0 : _182.certificates;
                //Get the certificates
                if (certs.length > 0) {
                    certs = certs.map(function (c, id) {
                        return {
                            id: c.id,
                            name: c.title,
                            url: c.url,
                            status: c.status,
                        };
                    });
                }
                setCertificates(certs);
                //Get the additional payment info
                if ((responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) && isQuote && isQuote === "false") {
                    var additionalInfo = [];
                    var data = responseOneQuote.data;
                    var lastPrice = data.lastPrice, customerAccount = data.customerAccount, catalogPaymentMode_1 = data.catalogPaymentMode, id_1 = data.id;
                    var amount_1 = (_183 = lastPrice === null || lastPrice === void 0 ? void 0 : lastPrice.amount) !== null && _183 !== void 0 ? _183 : "0.00";
                    var currencySymbol_1 = (lastPrice === null || lastPrice === void 0 ? void 0 : lastPrice.currencySymbol) || "";
                    var formattedAmount = formatToTwoDecimals(amount_1);
                    additionalInfo.push({
                        id: id_1,
                        accountName: customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountName,
                        accountNumber: customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountNumber,
                        accountType: (_184 = customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountType) === null || _184 === void 0 ? void 0 : _184.description,
                        paymentMode: catalogPaymentMode_1 === null || catalogPaymentMode_1 === void 0 ? void 0 : catalogPaymentMode_1.description,
                        prime: "".concat(currencySymbol_1, " ").concat(formattedAmount),
                        lastDigits: "N/A",
                    });
                    setRows2(additionalInfo);
                }
            }
            else {
                setRows2([
                    {
                        id: "1",
                        accountName: "N/A",
                        accountNumber: "N/A",
                        accountType: "N/A",
                        paymentMode: "N/A",
                        prime: "N/A",
                        lastDigits: "N/A",
                    },
                ]);
            }
            /*Adiciona al resumen la informacion de vehiculos*/
            switch ((_186 = (_185 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _185 === void 0 ? void 0 : _185.contentMap) === null || _186 === void 0 ? void 0 : _186.condition) {
                case "USED":
                    carConditionName = "Usado";
                    break;
                case "NEW":
                    carConditionName = "Nuevo";
                    break;
            }
            var price = ((_188 = (_187 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _187 === void 0 ? void 0 : _187.lastPrice) === null || _188 === void 0 ? void 0 : _188.currencySymbol) &&
                ((_190 = (_189 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _189 === void 0 ? void 0 : _189.lastPrice) === null || _190 === void 0 ? void 0 : _190.amount)
                ? "".concat(afy_currency !== null && afy_currency !== void 0 ? afy_currency : (_192 = (_191 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _191 === void 0 ? void 0 : _191.lastPrice) === null || _192 === void 0 ? void 0 : _192.currencySymbol, " ").concat(formatToTwoDecimals((_194 = (_193 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _193 === void 0 ? void 0 : _193.lastPrice) === null || _194 === void 0 ? void 0 : _194.amount))
                : "RD$ 0.00";
            var baseFilters = [
                {
                    name: "Producto",
                    type: "label",
                    label: (_197 = (_196 = (_195 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _195 === void 0 ? void 0 : _195.productId) === null || _196 === void 0 ? void 0 : _196.description) !== null && _197 !== void 0 ? _197 : "",
                },
                {
                    name: "Plan",
                    type: "label",
                    label: (_200 = (_199 = (_198 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _198 === void 0 ? void 0 : _198.planId) === null || _199 === void 0 ? void 0 : _199.name) !== null && _200 !== void 0 ? _200 : "",
                    showChangeButton: canChangePolicy,
                },
                {
                    name: "Modalidad de Pago",
                    type: "label",
                    label: (function () {
                        var _a, _b, _c, _d, _e;
                        var desc = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description;
                        if (desc)
                            return desc;
                        var freq = (_d = (_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.additionalDataMap) === null || _d === void 0 ? void 0 : _d.paymentFrequency;
                        if (!freq)
                            return "";
                        var freqMap = {
                            ANNUAL: "Anual",
                            MONTHLY: "Mensual",
                            QUARTERLY: "Trimestral",
                            SEMIANNUAL: "Semestral",
                        };
                        return (_e = freqMap[freq]) !== null && _e !== void 0 ? _e : freq;
                    })(),
                    showChangeButton: canChangePolicy,
                },
                {
                    name: "Tipo de Cobertura",
                    type: "label",
                    label: (_206 = (_203 = (_202 = (_201 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _201 === void 0 ? void 0 : _201.coverType) === null || _202 === void 0 ? void 0 : _202.description) !== null && _203 !== void 0 ? _203 : (_205 = (_204 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _204 === void 0 ? void 0 : _204.coverType) === null || _205 === void 0 ? void 0 : _205.name) !== null && _206 !== void 0 ? _206 : "",
                    showChangeButton: canChangePolicy,
                },
                {
                    name: "Campaña",
                    type: "label",
                    label: (_209 = (_208 = (_207 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _207 === void 0 ? void 0 : _207.campaignId) === null || _208 === void 0 ? void 0 : _208.name) !== null && _209 !== void 0 ? _209 : "",
                },
            ];
            var labelPrice = ((_211 = (_210 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _210 === void 0 ? void 0 : _210.catalogStatusQuote) === null || _211 === void 0 ? void 0 : _211.code) !== "G"
                ? afy_label_premium !== null && afy_label_premium !== void 0 ? afy_label_premium : "Prima"
                : "Prima";
            var filtersPlan = [
                {
                    name: labelPrice,
                    type: "label",
                    label: price,
                },
            ];
            setDefaultFilters(__spreadArray(__spreadArray([], baseFilters, true), filtersPlan, true));
            setReferrerRows([
                {
                    id: 1,
                    names: (_214 = (_213 = (_212 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _212 === void 0 ? void 0 : _212.user) === null || _213 === void 0 ? void 0 : _213.fullName) !== null && _214 !== void 0 ? _214 : "",
                    employeeCode: (_217 = (_216 = (_215 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _215 === void 0 ? void 0 : _215.user) === null || _216 === void 0 ? void 0 : _216.employeeCode) !== null && _217 !== void 0 ? _217 : "",
                    employeePosition: (_220 = (_219 = (_218 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _218 === void 0 ? void 0 : _218.user) === null || _219 === void 0 ? void 0 : _219.employeePosition) !== null && _220 !== void 0 ? _220 : "",
                    branch: (_223 = (_222 = (_221 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _221 === void 0 ? void 0 : _221.branchData) === null || _222 === void 0 ? void 0 : _222.name) !== null && _223 !== void 0 ? _223 : "",
                    quoteDate: ((_224 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _224 === void 0 ? void 0 : _224.creationDate)
                        ? formattedDate(responseOneQuote.data.creationDate)
                        : "",
                    policyDate: ((_226 = (_225 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _225 === void 0 ? void 0 : _225.policyId) === null || _226 === void 0 ? void 0 : _226.effectiveFrom)
                        ? formattedDate(responseOneQuote.data.policyId.effectiveFrom)
                        : "",
                },
            ]);
            var selectedPm = {
                id: (_228 = (_227 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _227 === void 0 ? void 0 : _227.catalogPaymentMode) === null || _228 === void 0 ? void 0 : _228.id,
                name: ((_230 = (_229 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _229 === void 0 ? void 0 : _229.catalogPaymentMode) === null || _230 === void 0 ? void 0 : _230.description) ||
                    "From Quote Response",
                value: ((_232 = (_231 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _231 === void 0 ? void 0 : _231.catalogPaymentMode) === null || _232 === void 0 ? void 0 : _232.code) ||
                    ((_234 = (_233 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _233 === void 0 ? void 0 : _233.catalogPaymentMode) === null || _234 === void 0 ? void 0 : _234.id),
            };
            callDispatchPlan(selectedPm, undefined, (_236 = (_235 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _235 === void 0 ? void 0 : _235.planId) === null || _236 === void 0 ? void 0 : _236.projectId);
        }
        dispatch(projectOneClearData());
    }, [
        responseOneQuote,
        downloadsStatusDenyList,
        isThereTabPaymentStatusAllowList,
    ]);
    useEffect(function () {
        if (responseOneProject) {
            if (id) {
                setLocalStorage(responseOneProject);
            }
            dispatch(projectOneClearData());
        }
    }, [responseOneProject]);
    useEffect(function () {
        var _a, _b;
        if (responseGetCatalogBeneficiary && (responseGetCatalogBeneficiary === null || responseGetCatalogBeneficiary === void 0 ? void 0 : responseGetCatalogBeneficiary.data)) {
            var beneficiaryList_1 = [];
            (_a = responseGetCatalogBeneficiary.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                beneficiaryList_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                });
            });
            setBeneficiaryType(beneficiaryList_1);
            setDataFormBeneficiary(__assign(__assign({}, dataFormBeneficiary), { idTypeInsured: (_b = beneficiaryList_1[0].value) !== null && _b !== void 0 ? _b : "" }));
        }
    }, [responseGetCatalogBeneficiary]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (responseGetCatalogInsurance && (responseGetCatalogInsurance === null || responseGetCatalogInsurance === void 0 ? void 0 : responseGetCatalogInsurance.data)) {
            var insuranceList_1 = [];
            (_a = responseGetCatalogInsurance.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                var _a;
                insuranceList_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                    code: (_a = item.code) !== null && _a !== void 0 ? _a : "",
                });
            });
            setInsuredType(insuranceList_1);
            setDataFormInsurance(__assign(__assign({}, dataFormInsurance), { idInsuredType: (_b = insuranceList_1[0].value) !== null && _b !== void 0 ? _b : "" }));
            // Buscar el elemento que contenga "Titular" o "titular"
            var titularItem = insuranceList_1.find(function (item) {
                return item.name.toLowerCase().includes("titular");
            });
            setInsuranceType((_d = (_c = titularItem === null || titularItem === void 0 ? void 0 : titularItem.value) !== null && _c !== void 0 ? _c : insuranceList_1[0].value) !== null && _d !== void 0 ? _d : "");
            setDataFormInsuranceSp(__assign(__assign({}, dataFormInsuranceSp), { idInsuredType: (_f = (_e = titularItem === null || titularItem === void 0 ? void 0 : titularItem.value) !== null && _e !== void 0 ? _e : insuranceList_1[0].value) !== null && _f !== void 0 ? _f : "" }));
        }
    }, [responseGetCatalogInsurance]);
    useEffect(function () {
        var _a, _b, _c;
        if (responsePlans) {
            var dataST_1 = [];
            // Prioritize payment mode from quote data
            var paymentModeFromQuote = (_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description;
            var pm = (_c = localStorageService.getStepStored().steps[Steps.plan]
                .paymentModeSelected) === null || _c === void 0 ? void 0 : _c.name;
            // User selection takes priority; fall back to quote data, then localStorage
            var paymentPeriod_1 = period || paymentModeFromQuote || pm;
            if (period === undefined && paymentPeriod_1) {
                setPeriod(paymentPeriod_1);
            }
            responsePlans
                .filter(function (item) { var _a, _b; return item.price && Number((_b = (_a = item.price) === null || _a === void 0 ? void 0 : _a.amount) === null || _b === void 0 ? void 0 : _b.replace(/,/g, "")) > 0; })
                .map(function (item) {
                var _a;
                dataST_1.push({
                    id: item.id,
                    name: item.name ? item.name.replace(/"/g, "") : "",
                    logo: item.sponsorLogoUrl && item.sponsorLogoUrl,
                    backgroundColor: "#ffffff",
                    currency: "$",
                    itemsValue: [],
                    option: setCoverTypeStorybook(item.coverTypes ? item.coverTypes : [], (coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.id) || (coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.value)),
                    period: paymentPeriod_1,
                    price: (_a = item.price) === null || _a === void 0 ? void 0 : _a.amount,
                    textColor: "#3A56A1",
                    paymentMethod: paymentModelSelected,
                });
            });
            setPlanData(__assign(__assign({}, plan), { data: dataST_1 }));
        }
    }, [
        responsePlans,
        responseOneQuote,
        paymentModelSelected,
        coverTypeSelected,
    ]);
    useEffect(function () {
        if (isLegacyQuote) {
            if (!showComponent) {
                setShowComponent(true);
            }
            return;
        }
        if (listIdentificationType.length > 0 &&
            listGenders.length > 0 &&
            listCountries.length > 0 &&
            listRegionLevel1.length > 0 &&
            listRegionLevel2.length > 0 &&
            listRegionLevel3.length > 0 &&
            !showComponent) {
            setShowComponent(true);
        }
    }, [
        isLegacyQuote,
        listIdentificationType,
        listGenders,
        listCountries,
        listRegionLevel1,
        listRegionLevel2,
        listRegionLevel3,
    ]);
    // Sólo persiste la respuesta de la API y actualiza el estado de flags.
    // El procesamiento real ocurre en el effect de actionFlags de abajo.
    useEffect(function () {
        if (responsePageActionFlags) {
            lsPageActionFlags.setPageActionFlagsStored(responsePageActionFlags);
            setActionFlags(responsePageActionFlags);
            setActionFlagsLoaded(true);
            dispatch(pageActionFlagsClearData());
        }
    }, [responsePageActionFlags]);
    // Procesa los flags cada vez que cambian (API o localStorage al montar).
    // Esto garantiza que getActionFlags() siempre recibe los flags actuales.
    useEffect(function () {
        if (!actionFlags || actionFlags.length === 0)
            return;
        getActionFlags();
        // defaults antes del forEach
        setIsThereShowTabPaymentStatusAllowList(false);
        setShowTabPaymentStatusAllowList([]);
        setHideTabDocumentClient(isApapAuto && (isQuote === "true" || isQuote === undefined));
        actionFlags.forEach(function (actionFlag) {
            if (actionFlag.name === "afy-show-plan-travel-range-info") {
                setIsTravelInsurance(true);
            }
            if (actionFlag.name === "afy-confirm-data-downloads-status-denylist") {
                var statusdenylist_1 = JSON.parse(actionFlag.value);
                setDownloadsStatusDenyList(function (prev) {
                    if (JSON.stringify(prev) === JSON.stringify(statusdenylist_1))
                        return prev;
                    return statusdenylist_1;
                });
            }
            if (actionFlag.name === "afy-confirm-data-show-tab-payment-status-allowlist") {
                setIsThereShowTabPaymentStatusAllowList(true);
                var statusallowlist_1 = JSON.parse(actionFlag.value);
                setShowTabPaymentStatusAllowList(function (prev) {
                    if (JSON.stringify(prev) === JSON.stringify(statusallowlist_1))
                        return prev;
                    return statusallowlist_1;
                });
            }
            if (actionFlag.name === "afy-confirm-data-show-tab-client-documents") {
                setHideTabDocumentClient(actionFlag.value !== "true");
            }
            if (actionFlag.name === "afy-conf-holidays-rd") {
                var holidaysList_1 = JSON.parse(actionFlag.value);
                setHolidays(function (prev) {
                    if (JSON.stringify(prev) === JSON.stringify(holidaysList_1))
                        return prev;
                    return holidaysList_1;
                });
            }
            if (actionFlag.name === "afy-asesor-rolid") {
                setRolAsesorId(actionFlag.value);
            }
        });
    }, [actionFlags]);
    useEffect(function () {
        if (responsePolicyConfirm && (responsePolicyConfirm === null || responsePolicyConfirm === void 0 ? void 0 : responsePolicyConfirm.data)) {
            showToastSuccessMessage("Correo enviado con éxito", typeAlert.success, setSeeToast);
            // El envío recién hecho debe aparecer en el historial de correos
            refetchMailHistory();
            dispatch(policyConfirmClearData());
        }
    }, [responsePolicyConfirm]);
    useEffect(function () {
        if (responsePatchBeneficiary && responsePatchBeneficiary.data) {
            showToastSuccessMessage("Beneficiario actualizado con éxito.", typeAlert.success, setSeeToast);
            setOpenModal(false);
            dispatch(patchBeneficiaryClearData());
            getInsuredBeneficiary();
        }
    }, [responsePatchBeneficiary]);
    useEffect(function () {
        var _a;
        // responsePatchQuote starts as null, becomes `true` while loading,
        // and becomes the payload (with .data) on success. Only react on success.
        if (responsePatchQuote &&
            responsePatchQuote !== true &&
            (responsePatchQuote === null || responsePatchQuote === void 0 ? void 0 : responsePatchQuote.data)) {
            showToastSuccessMessage("Cotización actualizada con éxito.", typeAlert.success, setSeeToast);
            dispatch(patchQuoteClearData());
            callQuoteOne((_a = id !== null && id !== void 0 ? id : quoteId) !== null && _a !== void 0 ? _a : "");
        }
    }, [responsePatchQuote]);
    useEffect(function () {
        if (errorPatchQuote) {
            showToastSuccessMessage("No se pudo actualizar la cotización.", typeAlert.error, setSeeToast);
            dispatch(patchQuoteClearData());
        }
    }, [errorPatchQuote]);
    useEffect(function () {
        if (responsePatchInsured && responsePatchInsured.data) {
            showToastSuccessMessage("Asegurado actualizado con éxito.", typeAlert.success, setSeeToast);
            setOpenModal(false);
            setOpenModalAddInsurance(false);
            dispatch(patchInsuredClearData());
            getInsuredBeneficiary();
        }
    }, [responsePatchInsured]);
    useEffect(function () {
        var _a;
        if (responsePostInsured) {
            showToastSuccessMessage("Asegurado agregado con éxito.", typeAlert.success, setSeeToast);
            dispatch(postInsuredClearData());
            setOpenModal(false);
            setOpenModalAddInsurance(false);
            dispatch(patchInsuredClearData());
            getInsuredBeneficiary();
            callQuoteOne((_a = id !== null && id !== void 0 ? id : quoteId) !== null && _a !== void 0 ? _a : "");
        }
    }, [responsePostInsured]);
    useEffect(function () {
        if (responseUpdatePerson === null || responseUpdatePerson === void 0 ? void 0 : responseUpdatePerson.data) {
            showToastSuccessMessage("Agregado con éxito.", typeAlert.success, setSeeToast);
            dispatch(quoteClearData());
            dispatch(quoteOne({ id: id !== null && id !== void 0 ? id : quoteId, fullBody: true }));
            dispatch(updatePersonClearData());
        }
    }, [responseUpdatePerson]);
    useEffect(function () {
        if (responseBenefit && (responseBenefit === null || responseBenefit === void 0 ? void 0 : responseBenefit.data)) {
            showToastSuccessMessage("Beneficiario agregado con éxito.", typeAlert.success, setSeeToast);
            setOpenModalBeneficiary(false);
            getInsuredBeneficiary();
            dispatch(benefitClearData());
        }
    }, [responseBenefit]);
    useEffect(function () {
        if (responsePlan && responsePlan.data) {
            /* Payment modes are now loaded from dedicated API - see useEffect for responsePaymentMode */
            /* Filtrar por coverage type */
            var result = filterData(responsePlan.data, "type", catalogConst.CATALOG_BENEFICIARY_TYPE);
            if (result.length > 0) {
                setCoverageType(result);
            }
            /* Filtrar por insured type */
            result = filterData(responsePlan.data, "type", catalogConst.CATALOG_INSURED_TYPE);
            /* Filtrar por beneficiary type */
            result = filterData(responsePlan.data, "type", catalogConst.CATALOG_BENEFICIARY_TYPE);
        }
    }, [responsePlan]);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (responseIdentificationType &&
            ((_a = responseIdentificationType.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var idf_1 = [];
            (_b = responseIdentificationType.data) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                idf_1.push({
                    id: item.id,
                    name: item.description ? item.description : "",
                    value: item.id,
                });
            });
            setListIdentificationType(idf_1);
            setDataFormBeneficiary(__assign(__assign({}, dataFormBeneficiary), { IdType: (_c = idf_1[0].value) !== null && _c !== void 0 ? _c : "" }));
            setDataFormInsurance(__assign(__assign({}, dataFormInsurance), { IdType: (_d = idf_1[0].value) !== null && _d !== void 0 ? _d : "" }));
            setDataFormInsuranceSp(__assign(__assign({}, dataFormInsuranceSp), { idType: (_e = idf_1[0].value) !== null && _e !== void 0 ? _e : "" }));
        }
    }, [responseIdentificationType]);
    useEffect(function () {
        var _a, _b;
        if (responseCatalogGender && ((_a = responseCatalogGender.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var data = (_b = responseCatalogGender.data) === null || _b === void 0 ? void 0 : _b.map(function (gender) {
                return {
                    id: gender.id,
                    value: gender.id,
                    name: gender.description,
                };
            });
            setListGenders(data);
        }
    }, [responseCatalogGender]);
    useEffect(function () {
        var _a, _b;
        if (responseCountries && ((_a = responseCountries.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var data = (_b = responseCountries.data) === null || _b === void 0 ? void 0 : _b.map(function (country) {
                return {
                    id: country.id,
                    value: country.id,
                    name: country.description,
                };
            });
            setListCountries(data);
        }
    }, [responseCountries]);
    useEffect(function () {
        var _a;
        if (responseRegion && (responseRegion === null || responseRegion === void 0 ? void 0 : responseRegion.data)) {
            var data = (_a = responseRegion.data) === null || _a === void 0 ? void 0 : _a.map(function (region) {
                return {
                    id: region.id,
                    value: region.id,
                    name: region.name,
                };
            });
            data.unshift({ id: "-1", value: "-1", name: " " });
            if (responseRegion.level === level1) {
                setListRegionLevel1(data);
            }
            else if (responseRegion.level === level2) {
                if (data.length > 0) {
                    setListRegionLevel2(data);
                }
                else {
                    setListRegionLevel2([{ id: "-1", value: "-1", name: " " }]);
                }
            }
            else if (responseRegion.level === level3) {
                if (data.length > 0) {
                    setListRegionLevel3(data);
                }
                else {
                    setListRegionLevel3([{ id: "-1", value: "-1", name: " " }]);
                }
            }
        }
    }, [responseRegion]);
    useEffect(function () {
        if (responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data) {
            setBeneficiaryStorybook(responseBeneficiary.data);
        }
    }, [responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data]);
    useEffect(function () {
        if (responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data) {
            setInsuranceStorybook(responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data);
            setSessionData(responseInsured);
        }
    }, [responseInsured]);
    useEffect(function () {
        if (actionFlags.length > 0) {
            getActionFlags();
        }
    }, [actionFlags]);
    // Override Prima in localStorage summary with contentMap.premium when travel insurance
    useEffect(function () {
        var _a, _b;
        if (isTravelInsurance &&
            ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.contentMap) === null || _b === void 0 ? void 0 : _b.premium) != null) {
            addToSummary([
                {
                    label: "Prima",
                    value: "USD ".concat(responseOneQuote.data.contentMap.premium),
                },
            ]);
        }
    }, [isTravelInsurance, (_0 = (_z = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _z === void 0 ? void 0 : _z.contentMap) === null || _0 === void 0 ? void 0 : _0.premium]);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (isLegacyQuote) {
            return;
        }
        if (!((_a = summary === null || summary === void 0 ? void 0 : summary.data) === null || _a === void 0 ? void 0 : _a.length)) {
            setFilters(defaultFilters);
            return;
        }
        var byLabel = Object.fromEntries(summary.data.map(function (i) { return [i.label, i.value]; }));
        // Orden grupo deseado
        var header = ["Documento", "No. de cotización"];
        var cliente = ["Nombres", "Apellidos"];
        var used = new Set(__spreadArray(__spreadArray([], header, true), cliente, true));
        var producto = summary.data.filter(function (i) { return !used.has(i.label); });
        var out = __spreadArray([
            {
                name: "Número de cotización",
                label: (_b = byLabel["No. de cotización"]) !== null && _b !== void 0 ? _b : "-",
                type: "label",
            },
            {
                name: "Número de documento",
                label: (_c = byLabel["Documento"]) !== null && _c !== void 0 ? _c : "-",
                type: "label",
            },
            // Subtítulo cliente
            {
                name: "Datos del cliente",
                label: "Datos del cliente",
                type: "subtitle",
            },
            { name: "Nombres", label: (_d = byLabel["Nombres"]) !== null && _d !== void 0 ? _d : "-", type: "label" },
            { name: "Apellidos", label: (_e = byLabel["Apellidos"]) !== null && _e !== void 0 ? _e : "-", type: "label" },
            // Subtítulo producto
            {
                name: "Datos del producto",
                label: "Datos del producto",
                type: "subtitle",
            }
        ], producto.map(function (e) {
            var _a, _b, _c, _d;
            var labelValue = e.value;
            if (e.label === "Prima") {
                if (isTravelInsurance &&
                    ((_b = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.contentMap) === null || _b === void 0 ? void 0 : _b.premium) != null) {
                    labelValue = "USD ".concat(responseOneQuote.data.contentMap.premium);
                }
                else {
                    labelValue = prime || e.value;
                }
            }
            if (e.label === afy_label_premium) {
                labelValue = prime || e.value;
                e.label =
                    ((_d = (_c = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _c === void 0 ? void 0 : _c.catalogStatusQuote) === null || _d === void 0 ? void 0 : _d.code) !== "G"
                        ? afy_label_premium !== null && afy_label_premium !== void 0 ? afy_label_premium : "Prima"
                        : "Prima";
            }
            var name = e.label;
            var showChangeButton = isQuoteType &&
                (name === "Plan" ||
                    name === "Modalidad de Pago" ||
                    name === "Tipo de Cobertura");
            return __assign({ name: name, label: labelValue, type: "label" }, (showChangeButton ? { showChangeButton: true } : {}));
        }), true);
        setFilters(out);
    }, [
        summary,
        defaultFilters,
        prime,
        isTravelInsurance,
        (_2 = (_1 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _1 === void 0 ? void 0 : _1.contentMap) === null || _2 === void 0 ? void 0 : _2.premium,
    ]);
    useEffect(function () {
        if (responsePersonByDocument && responsePersonByDocument.length > 0) {
            var dataPerson = responsePersonByDocument[0];
            var updatedDataFormPerson = updateDataFormPerson(dataPerson, isInsurance ? dataFormInsurance : dataFormBeneficiary);
            if (isInsurance) {
                setDataFormInsurance(updatedDataFormPerson);
            }
            else {
                setDataFormBeneficiary(updatedDataFormPerson);
            }
            setTrigger(false);
            dispatch(personByDocumentClearData());
        }
        if ((responsePersonByDocument === null || responsePersonByDocument === void 0 ? void 0 : responsePersonByDocument.length) === 0) {
            if (isInsurance) {
                setDataFormInsurance({
                    Name: "",
                    SecondName: "",
                    LastNameA: "",
                    LastNameB: "",
                    marriedName: "",
                    Birthday: "",
                    PhoneNumber: "",
                });
            }
            else {
                setDataFormBeneficiary({
                    Name: "",
                    SecondName: "",
                    LastNameA: "",
                    LastNameB: "",
                    marriedName: "",
                    Birthday: "",
                    PhoneNumber: "",
                });
            }
            dispatch(personByDocumentClearData());
        }
    }, [responsePersonByDocument, isInsurance, trigger]);
    useEffect(function () {
        setUploadTrigger(false);
        setOpenDrawerUpload(false);
        dispatch(postQuoteUploadDocumentClearData());
        if (id !== undefined) {
            dispatch(quoteClearData());
            callQuoteOne(id);
        }
        else {
            callQuoteOne(quoteId);
        }
        if (responseUploadDocuments) {
            window.dispatchEvent(new CustomEvent("pendingDocumentsChanged"));
        }
    }, [responseUploadDocuments]);
    var deleteInsured = React.useCallback(function (params) {
        var _a;
        var insuredId = (_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.id;
        if (!insuredId)
            return;
        dispatch(deleteInsuredAction({
            id: insuredId,
            body: { force: false },
        }));
    }, [dispatch]);
    useEffect(function () {
        var _a, _b;
        if (!responseDeleteInsured && !errorDeleteInsured)
            return;
        if (responseDeleteInsured) {
            dispatch(insured({
                enable: true,
                page: 1,
                limit: 100,
                quoteId: quoteId ? quoteId : id,
            }));
            setSeeToast({
                show: true,
                message: "Asegurado eliminado correctamente.",
                type: typeAlert.success,
            });
            callQuoteOne((_a = id !== null && id !== void 0 ? id : quoteId) !== null && _a !== void 0 ? _a : "");
        }
        if (errorDeleteInsured) {
            setSeeToast({
                show: true,
                message: (_b = errorDeleteInsured === null || errorDeleteInsured === void 0 ? void 0 : errorDeleteInsured.message) !== null && _b !== void 0 ? _b : "No se pudo eliminar el asegurado. Intente nuevamente.",
                type: typeAlert.error,
            });
        }
        dispatch(deleteInsuredClearData());
    }, [responseDeleteInsured, errorDeleteInsured]);
    var columnsInsurance = Tab1Columns(editInsured, deleteInsured, canEditInsured && !isLegacyQuote, rows);
    var columnsBeneficiary = Tab2Columns(editBeneficiary, canEditBeneficiary);
    var callGetInsuredBeneficiary = function (quoteId) {
        var id_ = quoteId;
        if (id_) {
            if (!(responseInsured === null || responseInsured === void 0 ? void 0 : responseInsured.data) && !(responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data)) {
                dispatch(getBeneficiary({
                    enable: true,
                    page: 1,
                    limit: 100,
                    quoteId: id_,
                }));
                dispatch(insured({
                    enable: true,
                    page: 1,
                    limit: 100,
                    quoteId: id_,
                }));
            }
        }
    };
    // Passenger Download Modal State
    var _193 = useState(false), openPassengerModal = _193[0], setOpenPassengerModal = _193[1];
    var _194 = useState(false), openModalAddPassenger = _194[0], setOpenModalAddPassenger = _194[1];
    var _195 = useState(""), selectedQuoteId = _195[0], setSelectedQuoteId = _195[1];
    var _196 = useState(null), editingPassengerId = _196[0], setEditingPassengerId = _196[1];
    var _197 = useState(null), editingPassengerData = _197[0], setEditingPassengerData = _197[1];
    var handleAddPassanger = function () {
        setEditingPassengerId(null);
        setEditingPassengerData(null);
        setOpenModalAddPassenger(true);
    };
    var onClickPassangerDownload = React.useCallback(function () {
        setSelectedQuoteId(quoteId);
        setOpenPassengerModal(true);
    }, [quoteId]);
    var handlePassengerModalClose = React.useCallback(function () {
        setOpenPassengerModal(false);
        setSelectedQuoteId("");
    }, []);
    var handleOpenPdf = React.useCallback(function (url, name) {
        setUrlDocumentPassenger(url);
        setNameDocumentPassenger(name);
        setOpenModalPassenger(true);
    }, []);
    var _198 = React.useState(false), triggerAddAppointmentAction = _198[0], setTriggerAddAppointmentAction = _198[1];
    var columnsAppointment = TabAppointmentColumns(false, false);
    var columnsAppointmentManager = TabAppointmentManagerColumns(false, false);
    var _199 = useAppointment((_4 = (_3 = id !== null && id !== void 0 ? id : quoteIdLS) !== null && _3 !== void 0 ? _3 : quoteId) !== null && _4 !== void 0 ? _4 : "", showTabAppointment), appointmentRows = _199.appointmentRows, appointmentId = _199.appointmentId, setAppointmentRows = _199.setAppointmentRows, setExecutiveUserId = _199.setExecutiveUserId, setAppointmentId = _199.setAppointmentId, executiveUserId = _199.executiveUserId, loadingGetAppointmentAction = _199.loadingGetAppointmentAction, callAppointment = _199.callAppointment;
    var _200 = useAppointmentManager(appointmentId, setOpenModalAddAppointmentAction, setTriggerAddAppointmentAction, triggerAddAppointmentAction, showTabAppointmentManager, (_5 = lsLogin.getUserLoginStored().user.id) !== null && _5 !== void 0 ? _5 : "", setSeeToast, holidays, appointmentRows, quoteId, executiveUserId, setAppointmentRows, setAppointmentId, setExecutiveUserId, rolAsesorid, callQuoteOne, (_7 = (_6 = id !== null && id !== void 0 ? id : quoteIdLS) !== null && _6 !== void 0 ? _6 : quoteId) !== null && _7 !== void 0 ? _7 : "", callAppointment), appointmentManagerRows = _200.appointmentManagerRows, handleAddAppointmetAction = _200.handleAddAppointmetAction, handleSubmitAppointmentAction = _200.handleSubmitAppointmentAction, formAppointmentActionProps = _200.formAppointmentActionProps, loadingAppointmentActionPatch = _200.loadingAppointmentActionPatch, loadingAppointmentPost = _200.loadingAppointmentPost, quotePriceLoading = _200.quotePriceLoading;
    var effectiveQuoteId = id ? id : quoteId;
    var loggedUser = lsLogin.getUserLoginStored();
    var loggedUserId = (_10 = (_9 = (_8 = loggedUser.user) === null || _8 === void 0 ? void 0 : _8.id) !== null && _9 !== void 0 ? _9 : loggedUser.userId) !== null && _10 !== void 0 ? _10 : "";
    var loggedUserName = [
        (_12 = (_11 = loggedUser.idToken) === null || _11 === void 0 ? void 0 : _11.payload) === null || _12 === void 0 ? void 0 : _12.name,
        (_14 = (_13 = loggedUser.idToken) === null || _13 === void 0 ? void 0 : _13.payload) === null || _14 === void 0 ? void 0 : _14.family_name,
    ]
        .filter(Boolean)
        .join(" ")
        .trim() || loggedUser.userName;
    var currentCreatorType = "manager";
    var _201 = useQuoteComments({
        quoteId: effectiveQuoteId,
        currentUserId: loggedUserId,
        currentUserName: loggedUserName,
        currentCreatorType: currentCreatorType,
        showComments: showComments,
        setSeeToast: setSeeToast,
        t: t,
    }), quoteComments = _201.comments, loadingPostComment = _201.loadingPostComment, loadingPutComment = _201.loadingPutComment, loadingDeleteComment = _201.loadingDeleteComment, loadingGetComments = _201.loadingGetComments, handleAddComment = _201.addComment, handleUpdateComment = _201.updateComment, handleDeleteComment = _201.deleteComment;
    var _202 = useAuditLogs({
        enable: showLogsInfo && !!effectiveQuoteId,
        page: 0,
        size: 100,
        orderDir: "ASC",
        quoteId: effectiveQuoteId,
        setSeeToast: setSeeToast,
        t: t,
    }), auditLogEntries = _202.logEntries, loadingGetAuditLogs = _202.loadingGetAuditLogs;
    return (_jsxs(React.Fragment, { children: [_jsx(PagesHeader, { titlePage: titleInsured, hideStep: isQuote === "false" || isLegacyQuote, steps: steps, completed: isQuote === "false" || isLastPage }), _jsx(ConfirmationHeader, { loading: loadingPostInsured ||
                    loadingUpdatePerson ||
                    loadingOneQuote ||
                    loadingBenefit ||
                    loadingPostInsured ||
                    loadingPatchBeneficiary ||
                    loadingPatchInsured ||
                    loadingPersonByDocument ||
                    loadingOneProject ||
                    loadingBeneficiary ||
                    loading ||
                    loadingPlans ||
                    loadingUpdateQuote ||
                    loadingUploadDocuments ||
                    loadingGetCatalogBeneficiary ||
                    loadingGetCatalogInsurance ||
                    loadingCertificateQuote ||
                    loadingInsured ||
                    loadingPaymentMode ||
                    loadingComplete ||
                    loadingCatalogues ||
                    loadingStartWorkFlow ||
                    loadingPatchQuote ||
                    loadingAppointmentActionPatch ||
                    loadingPostComment ||
                    loadingPutComment ||
                    loadingDeleteComment ||
                    loadingGetComments ||
                    responsePolicyConfirmLoading ||
                    loadingAppointmentPost ||
                    loadingGetAppointmentAction ||
                    quotePriceLoading ||
                    loadingLegacyQuote ||
                    loadingLegacyQuoteDetail ||
                    certificatesConversion.running, text: loadingUpdatePerson || loadingUpdateQuote || loadingPatchQuote
                    ? "Actualizando cotización..."
                    : loadingUploadDocuments
                        ? "Subiendo documento..."
                        : "Cargando...", seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast }), openPassengerModal && (_jsx(PassengerDownloadModal, { open: openPassengerModal, onClose: handlePassengerModalClose, setSeeToast: setSeeToast, quoteId: selectedQuoteId, onOpenPdf: handleOpenPdf })), showComponent ? (_jsx(Suspense, { children: _jsx(ConfirmationFormView, { isLegacyQuote: isLegacyQuote, onClickPassangerDownload: onClickPassangerDownload, isTravelInsurance: isTravelInsurance, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, breadcrumbs: breadCrumbs, steps: steps, 
                    /* PDF VIEWER DOCUMENT*/
                    openModal: openModalPdfViewer, setOpenModal: setopenModalPdfViewer, documentName: nameDocument, urlDocument: urlDocument, 
                    /* PDF VIEWER CLIENT*/
                    openModalClient: modalDocumentClient, setOpenModalClient: setModalDocumentClient, documentNameClient: docName, urlDocumentClient: urlDocumentClient, 
                    /* PDF VIEWER PASSENGER */
                    openModalPassenger: openModalPassenger, setOpenModalPassenger: setOpenModalPassenger, documentNamePassenger: nameDocumentPassenger, urlDocumentPassenger: urlDocumentPassenger, 
                    /* MODAL EDIT VEHICLE */
                    openModalEditVehicle: openModalEditVehicle, setOpenModalEditVehicle: setOpenModalEditVehicle, dataFormVehicle: dataFormVehicle, callQuoteOneApi: callQuoteOne, quoteId: id ? id : quoteId, planId: planId, coverTypeId: coverTypeId, campaignId: campaignId, catalogPaymentMode: catalogPaymentMode, catalogStatusQuote: catalogStatusQuote, branchId: branchId, userId: userId, idQuoteVehicle: idQuoteVehicle, productId: productId, t: t, planName: planName, productType: productType, projectTypeLocal: projectTypeLocal, salesFlow: salesFlow, 
                    /* MODAL BENEFICIARY */
                    openModalBeneficiary: openModalBeneficiary, setOpenModalBeneficiary: setOpenModalBeneficiary, isMaskedDocument: isMaskedDocument, dataFormBeneficiary: dataFormBeneficiary, titleBeneficiary: titleBeneficiary, beneficiaryType: beneficiaryType, listIdentificationType: listIdentificationType, initialPercentage: initialPercentage, handleSubmitBeneficiary: function () {
                        return handleSubmitBeneficiary(dataFormBeneficiary);
                    }, searchPerson: function (e) {
                        return searchPerson(e, setIsInsurance, setDocument, setTrigger);
                    }, 
                    /* MODAL INSURED */
                    openModalInsured: openModal, setOpenModalInsured: setOpenModal, dataFormInsurance: dataFormInsurance, titleInsured: titleInsured, insuredType: insuredType, handleSubmitInsured: function (data) { return handleSubmitInsured(data); }, searchInsurancePerson: function (e) { return searchInsurancePerson(e); }, 
                    /* MODAL CONFIRMATION */
                    openModalBackConfirm: openModalBackConfirm, handleCloseBackModal: handleCloseBackModal, handleBackFromModal: handleBackFromModal, classes: classes, 
                    /* VIEW */
                    isRequired: !isApap, tabAdditionalDocumentation: "Documentos Clientes", countBadgeContent: countBadge, customBadgeColor: "#fba730", badgeColorText: "#ffffff", additionalDocumentationColumns: AdditionalDocumentationColumns(handleClickContextMenu), additionalDocumentationRows: profileDocumentsRows, hideMarriedName: hideMarriedName, titleDrawer: "Suba el documento solicitado.", descriptionDrawer: "Arrastra el documento solicitado a la zona de color o haz clic en el área de color para seleccionarlo. Solo puedes subir un documento a la vez, y solo se permiten archivos en formato PDF.", titleUpload: "Arrastre y suelte su archivo.", heightDrawer: "100%", disableSelectCountry: true, openDrawerUpload: openDrawerUpload, onCloseDrawer: function () {
                        setOpenDrawerUpload(false);
                    }, onUpload: quoteUploadDocuments, tabAuto: "Auto Asegurado", tabAutoDescription: "", tabStatement: "Historial de cobranza", tabStatementColumns: StatementColumns(t), tabStatementRows: statementRows, TabAutoColumns: TabAutoColumns(updateVehicle, isQuote ? isQuote : ""), TabAutoRows: listVehiclesDetail, onChangeSelect: handleChangeSelect, handleChangeSelectFormInsurance: handleChangeSelectFormInsurance, 
                    // ***--- PROPS BOTONES DESCARGAR QUOTE DESDE RESUMEN
                    onClickAutoDownload: handleOnClickAutoDownload, btnLblDownload: "Descargar Cotización", btnDownloadQuoteBackground: "#ffffff", showButtonDownloadApap: !isLegacyQuote && (!showVehicleData || !showDownloadQuote), onClickAutoDownloadVida: handleOnClickAutoDownloadVida, btnLblDownloadVida: "Descargar Solicitud", showButtonDownloadVida: !isLegacyQuote && !showDownloadRequest, 
                    // ***--- END PROPS BOTONES DESCARGAR QUOTE DESDE RESUMEN
                    labelNumberQuote: "No. de cotización", labelPolicyNumber: (isLegacyQuote
                        ? !!((_15 = legacyQuoteData === null || legacyQuoteData === void 0 ? void 0 : legacyQuoteData.dataForm) === null || _15 === void 0 ? void 0 : _15.policeNumber)
                        : (_16 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _16 === void 0 ? void 0 : _16.policyId)
                        ? "No. de póliza"
                        : undefined, title: "Confirmación de datos", identificationList: isLegacyQuote
                        ? (_17 = legacyQuoteData === null || legacyQuoteData === void 0 ? void 0 : legacyQuoteData.identificationList) !== null && _17 !== void 0 ? _17 : []
                        : listIdentificationType, GenderList: isLegacyQuote ? (_18 = legacyQuoteData === null || legacyQuoteData === void 0 ? void 0 : legacyQuoteData.genderList) !== null && _18 !== void 0 ? _18 : [] : listGenders, CountryList: isLegacyQuote ? (_19 = legacyQuoteData === null || legacyQuoteData === void 0 ? void 0 : legacyQuoteData.countryList) !== null && _19 !== void 0 ? _19 : [] : listCountries, ProvinceList: isLegacyQuote
                        ? (_20 = legacyQuoteData === null || legacyQuoteData === void 0 ? void 0 : legacyQuoteData.provinceList) !== null && _20 !== void 0 ? _20 : []
                        : listRegionLevel1, TownList: isLegacyQuote ? (_21 = legacyQuoteData === null || legacyQuoteData === void 0 ? void 0 : legacyQuoteData.townList) !== null && _21 !== void 0 ? _21 : [] : listRegionLevel2, SectorList: isLegacyQuote
                        ? (_22 = legacyQuoteData === null || legacyQuoteData === void 0 ? void 0 : legacyQuoteData.sectorList) !== null && _22 !== void 0 ? _22 : []
                        : listRegionLevel3, dataForm: dataForm, hideTabs: isLegacyQuote
                        ? [
                            rows.length === 0,
                            rowsBeneficiary.length === 0,
                            true,
                            true,
                            true,
                            true,
                            true,
                            true,
                            true,
                            true,
                            true,
                            true,
                            true,
                            true,
                            true,
                        ]
                        : [
                            showInsured,
                            showBeneficiary,
                            hideTabPaymentInfo,
                            showVehicleData,
                            isNotQuote,
                            showDocumentClient,
                            !isTravelInsurance,
                            showTabRealEstates,
                            !showTabAppointment,
                            !showTabAppointmentManager,
                            !showTabReferrer,
                            !showComments,
                            false,
                            !showCardInformation,
                            !policyId, // Tab: Historial de correos - solo en póliza, que es cuando se envían correos
                        ], hideAddButton: [
                        addInsured,
                        addBeneficiary,
                        true,
                        true,
                        !addAppointmentAction,
                    ], showAdd: true, showActions: !isLegacyQuote && canEdit, showContactActions: !isLegacyQuote && canEditContact, showLocationActions: !isLegacyQuote && canEditLocation, showDownloads: isLegacyQuote
                        ? Boolean((_23 = legacyQuoteData === null || legacyQuoteData === void 0 ? void 0 : legacyQuoteData.dataForm) === null || _23 === void 0 ? void 0 : _23.policeNumber)
                        : showDownloads, onClickDownload: handleDownload, certificates: certificates, dateLabel: isQuote !== null && isQuote === "false"
                        ? "Fecha efectiva"
                        : "Fecha de cotización", downloadsTitle: "Descargas", labelAdd: "Agregar", tab1: "Personas aseguradas", tab1Description: "Asegurados", tab2: "Beneficiarios", tab2Description: "Beneficiarios", tab3: "Información de pago", tab3Description: "", Tab1Columns: columnsInsurance, Tab1Rows: rows, Tab2Columns: columnsBeneficiary, Tab2Rows: rowsBeneficiary, Tab3Columns: Tab3Columns, Tab3Rows: rows2, 
                    // tab card info
                    tabCardInfo: "Información de tarjeta", tabCardInfoDescription: "Datos de la tarjeta ", TabCardInfoColumns: TabCardInfoColumns, TabCardInfoRows: rowsCardInfo, 
                    //Travel Insurance Tab4
                    tab4: "Pasajeros", 
                    /////
                    Tab4Columns: Tab4Columns, Tab4Rows: rowsPassengers, hide2: true, options1: paymentMode, options2: [], options3: campaignInfo, firstSubtitle: "Información de cotización", secondSubtitle: "Información general del cliente", thirdSubtitle: "Información de ubicación", fourthSubtitle: "Información de contacto", plan: ((paymentModelSelected === null || paymentModelSelected === void 0 ? void 0 : paymentModelSelected.id) &&
                        catalogPaymentMode &&
                        paymentModelSelected.id !== catalogPaymentMode) ||
                        (((coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.id) || (coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.value)) &&
                            coverTypeId &&
                            ((coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.id) || (coverTypeSelected === null || coverTypeSelected === void 0 ? void 0 : coverTypeSelected.value)) !==
                                coverTypeId)
                        ? __assign(__assign({}, plan), { id: "" }) : plan, plans: planData.data || [], paymentMethodData: paymentMode, campaignData: campaign, showPaymentMethod: true, showCampaign: true, onClickAdd: handleAddInsured, onClickRowGrid: function () { }, onClickAddBeneficiary: handleAddBeneficiary, filters: filters, titleSelectButton: "Adquirir", previousLabel: "Anterior", nextLabel: !isVidaTermino ? "Siguiente" : "Finalizar", showPrevious: canEdit, nextDisabled: isLegacyQuote ||
                        !permissions.create ||
                        !canEdit ||
                        (navigation === null || navigation === void 0 ? void 0 : navigation.canNavigateNext) === false, onBack: onClickBack, onClickSave: handleUpdatePerson, onNext: handleNext, onClickPrevious: handlePrevious, onBlurInput: function () { }, onChangeInput: function () { }, onClickCancel: function () { }, disableDocumentType: true, disableDocumentNumber: true, onChangePaymentMethod: handleOnChangePaymentMethod, onChangeCampaign: handleOnChangeCampaign, onChangeCoverType: handleOnChangeCoverType, onClickAcquire: handleOnClickAcquire, disabledDownloadVida: false, isQuote: isQuote, isPlan: isPlan, openModalAddInsurance: openModalAddInsurance, setOpenModalAddInsurance: setOpenModalAddInsurance, dataFormInsuranceSp: dataFormInsuranceSp, showButtonActivatePolicy: showButtonActivatePolicy, showRequestCertificatesButton: showRequestCertificatesButton, disableRequestCertificatesButton: !legacyPolicyCode || certificatesConversion.running, onClickRequestCertificates: function () {
                        return certificatesConversion.start(legacyPolicyCode);
                    }, openActivePolicy: openActivePolicy, setOpenActivePolicy: setOpenActivePolicy, policyId: policyId, callQuoteOne: callQuoteOne, onClickAddPassanger: handleAddPassanger, openModalAddPassenger: openModalAddPassenger, setOpenModalAddPassenger: setOpenModalAddPassenger, editingPassengerData: editingPassengerData, handleSavePassenger: function () { }, 
                    //home/business
                    setOpenModalAddBusiness: setOpenModalAddBusiness, openModalAddBusiness: openModalAddBusiness, isCommerce: isCommerce, tab4Description: "", TabRealEstateRows: rowsProperties, dataFormBusiness: dataFormBusiness, damageBackup: damageBackup, insuredProperty: insuredProperty, showFormBusiness: showFormBusiness, openModalAddHome: openModalAddHome, setOpenModalAddHome: setOpenModalAddHome, onSameDirection: onSameDirection, productCode: productCode, planCode: planCode, setDataFormBusiness: setDataFormBusiness, businessShift: businessShift, businessType: businessType, typeConstruction: typeConstruction, 
                    // END home/business
                    //Appoinment
                    tabAppointment: "Cita", tabAppointmentDescription: "Información de Cita", tabAppointmentColumns: columnsAppointment, tabAppointmentRows: appointmentRows, 
                    //AppointmentManager
                    tabAppointmentManager: "Gestiones", tabAppointmentManagerDescription: "Gestiones", tabAppoinmentManagerColumns: columnsAppointmentManager, tabAppointmentManagerRows: appointmentManagerRows, onClickAddAppAction: handleAddAppointmetAction, openModalAddAppointmentAction: openModalAddAppointmentAction, setOpenModalAddAppointmentAction: setOpenModalAddAppointmentAction, handleSubmitAppointmentAction: handleSubmitAppointmentAction, formAppointmentActionProps: formAppointmentActionProps, showBranchSwitcher: !isLegacyQuote && !!((_24 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _24 === void 0 ? void 0 : _24.id), branchSwitcherCardTitle: "Sucursal", branchDisplayLabel: branchDisplayLabelForSwitcher, branchOptions: branchSwitcherOptions, selectedBranchId: (_26 = (_25 = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _25 === void 0 ? void 0 : _25.branch) !== null && _26 !== void 0 ? _26 : "", branchSwitcherDisabled: !permissions.create || loadingPatchQuote, branchSwitcherLoading: loadingPatchQuote, onBranchChange: handleBranchChange, branchSwitcherModalTitle: "Cambiar sucursal", referrerRows: referrerRows, currentUserId: loggedUserId, currentCreatorType: currentCreatorType, currentUserIsAdmin: false, comments: quoteComments, onAddComment: handleAddComment, onUpdateComment: handleUpdateComment, onDeleteComment: handleDeleteComment, commentsLabels: {
                        title: "Comentarios del expediente",
                        description: "Discusión interna",
                        placeholder: "Escribe un comentario...",
                        send: "Enviar",
                        cancel: "Cancelar",
                        reply: "Responder",
                        edit: "Editar",
                        delete: "Eliminar",
                        save: "Guardar",
                        attach: "Adjuntar",
                        emptyState: "Sin comentarios todavía",
                        inReplyTo: "Respondiendo a",
                        edited: "editado",
                        preview: "Vista previa",
                        download: "Descargar",
                        confirmDelete: "¿Eliminar este comentario?",
                        fileTooLarge: "Archivo demasiado grande",
                        fileTypeNotAllowed: "Tipo de archivo no permitido",
                        contentRequired: "El comentario no puede estar vacío",
                    }, tabLog: "Bit\u00E1cora", tabLogProps: {
                        showLogNumbers: false,
                        logMaxHeight: "220px",
                        tabLogDescription: "Bitácora de eventos.",
                        logEntries: loadingGetAuditLogs
                            ? ["Cargando bitácora..."]
                            : auditLogEntries.length > 0
                                ? auditLogEntries
                                : ["Sin eventos registrados."],
                    }, tabMailHistory: "Historial de correos", tabMailHistoryProps: {
                        mailHistoryItems: mailHistoryItems,
                        mailHistoryCertificate: mailHistoryCertificate,
                        mailHistoryPrintedAt: mailHistoryPrintedAt,
                        mailHistoryEmptyState: loadingMailHistory
                            ? "Cargando historial de correos..."
                            : undefined,
                        onDownloadMailHistoryExcel: function (items) {
                            return downloadMailHistory(items, mailHistoryCertificate, mailHistoryPrintedAt);
                        },
                    }, 
                    //CHANGE PAYMENT METHOD
                    showPaymentMethodCard: !isLegacyQuote &&
                        !!policyId &&
                        policyStatus.toLowerCase() === "activa", filterPaymentMethod: paymentMethodCardData, titlePaymentMethodCard: "Método de pago", onClickChangePaymentMethod: function () {
                        navigate("/checkout/payment-method/".concat(quoteId));
                    }, 
                    // END CHANGE PAYMENT METHOD
                    // sendMail
                    showSendEmailBox: !!policyId, defaultEmail: email, onClickSendEmail: handleSendEmail }) })) : (_jsx("div", {}))] }));
};
export default ConfirmationForm;
